export const en = {
  // Common
  common: {
    save: 'Save',
    saving: 'Saving...',
    cancel: 'Cancel',
    edit: 'Edit',
    view: 'View',
    add: 'Add',
    create: 'Create',
    update: 'Update',
    search: 'Search',
    filter: 'Filter',
    loading: 'Loading...',
    error: 'Error',
    success: 'Success',
    confirm: 'Confirm',
    yes: 'Yes',
    no: 'No',
    close: 'Close',
    back: 'Back',
    next: 'Next',
    previous: 'Previous',
    actions: 'Actions',
    status: 'Status',
    active: 'Active',
    inactive: 'Inactive',
    name: 'Name',
    email: 'Email',
    phone: 'Phone',
    date: 'Date',
    time: 'Time',
    description: 'Description',
    price: 'Price',
    total: 'Total',
    submit: 'Submit',
    reset: 'Reset',
    clear: 'Clear',
    refresh: 'Refresh',
    export: 'Export',
    import: 'Import',
    print: 'Print',
    download: 'Download',
    upload: 'Upload',
    select: 'Select',
    selectAll: 'Select All',
    deselectAll: 'Deselect All',
    none: 'None',
    all: 'All',
    required: 'Required',
    login: 'Login',
    register: 'Register',
    registering: 'Registering...',
    optional: 'Optional',
    delete: 'Delete',
    authorization:'Authorization',
    reprint:'Reprint',
    addItem:'Add Item',
    qty:'Qty',
    discount:'Discount',
    itemDescription:'Item description',
    type:'Type',
    selectType:'Select type',
    english: 'English',
    spanish: 'Spanish',
    register: 'Register',
    snackbar: {
      pleaseFillAllRequiredFields: 'Please fill in all required fields',
      nameRequired: 'Name is required',
      typeRequired: 'Type is required',
      commentRequired: 'Comment is required',
    },
  },

  // Navigation
  nav: {
    menus: 'Digital menu',
    loyalty: 'Loyalty',
    loyaltyCashier: 'Cashier',
    loyaltyMembers: 'Members',
    loyaltyRewards: 'Rewards',
    loyaltyPromotions: 'Promotions',
    loyaltyTransactions: 'Transactions',
    loyaltySettings: 'Program settings',
    dashboard: 'Dashboard',
    clients: 'Clients',
    cleaningDetails: 'Cleaning jobs',
    services: 'Services',
    serviceTypes: 'Service Types',
    serviceHistory: 'Service History',
    invoices: 'Invoices',
    calendar: 'Calendar',
    jobSchedule: 'Job schedule',
    employees: 'Employees',
    visits: 'Visits',
    settings: 'Settings',
    profile: 'Profile',
    logout: 'Logout',
    login: 'Login',
    budgetConfig: 'Budget Config',
    types: 'Types',
    units: 'Units',
    products: 'Products',
    students: 'Students',
    cycles: 'Cycles',
    grades: 'Grade Levels',
    cursos: 'Courses',
    pensums: 'Curriculum',
    notas: 'Student Grades',
    attendance: 'Attendance',
    markAttendance: 'Mark attendance',
    teacherAssignments: 'Teacher assignments',
    planification: 'Planification',
    planifications: 'Planifications',
    descounts: 'Discounts',
    paymentTypes: 'Payment Types',
    memberships: 'Membership',
    payments: 'Payments',
    administration: 'Administration',
    userManagement: 'User Management',
    tenantUsers: 'Tenant Users',
    tenantManagement: 'Tenant Management',
    tenantRegistration: 'Tenant Registration',
    tenantRoles: 'Tenant Roles',
    rolesPermissions: 'Roles & Permissions',
    permissionManagement: 'Permission Management',
    emailTemplates: 'Email Templates',
    clientEmailSettings: 'Client Email Settings',
    emailQueue: 'Email Queue',
    systemSettings: 'System Settings'
  },

  visitHistory: {
    title: 'Patient History',
    newVisit: 'New Visit',
    saving: 'Saving...',
    save: 'Save',
    edit: 'Edit',
    print: 'Print',
    printTime: 'Time',
    printPopupBlocked: 'Allow pop-ups in your browser to print.',
    dob: 'DOB',
    na: 'N/A',
    contactInfo: 'Contact Information',
    phone: 'Phone',
    medicalSummary: 'Medical Summary',
    allergiesNotes: 'Allergies & Notes',
    noMedicalSummary: 'No medical summary available.',
    noAllergies: 'No allergies registered.',
    changePhoto: 'Change photo',
    uploadPhoto: 'Upload patient photo',
    removePhoto: 'Remove photo',
    confirmRemovePhoto: 'Remove the patient photo and use the company logo instead?',
    photoUploading: 'Uploading photo...',
    photoUploadSuccess: 'Photo updated.',
    photoRemovedSuccess: 'Photo removed. Company logo will be used.',
    timeline: 'Visit Timeline',
    timelinePendingBadge: '{count} pending exam result(s)',
    timelinePendingBadgeShort: 'Pending results',
    visitType: 'Visit Type',
    status: 'Status',
    duration: 'Duration',
    defaultDuration: '45 minutes',
    tabs: {
      consultationNotes: 'Consultation Notes',
      prescribedExams: 'Prescribed Exams',
      prescription: 'Prescription',
      invoices: 'Invoices',
    },
    consultation: {
      chiefComplaint: 'Chief Complaint',
      chiefComplaintPlaceholder: "Patient's main concern or reason for visit...",
      physicalExamination: 'Physical Examination',
      physicalExaminationPlaceholder: 'Physical examination findings...',
      assessmentPlan: 'Assessment & Plan',
      assessmentPlanPlaceholder: "Doctor's assessment and treatment plan...",
    },
    exams: {
      addNewExam: 'Add New Exam',
      addExam: 'Add Exam',
      prescribedForVisit: 'Prescribed Exams for This Visit',
      empty: 'No exams prescribed yet. Add an exam to get started.',
      cancel: 'Cancel',
      saveExams: 'Save Exams',
      printOrders: 'Print Exam Orders',
      unknownExam: 'Unknown exam',
      unknownStatus: 'Unknown status',
      unknownPriority: 'Unknown priority',
      noReason: 'No reason specified',
      requested: 'Requested',
      notes: 'Notes',
      editExam: 'Edit Exam',
      newExam: 'New Exam',
      examType: 'Exam Type',
      selectExamType: 'Select exam type...',
      searchExamType: 'Search or type a new exam...',
      addExamTypeOption: 'Add "{name}"',
      examTypeRequired: 'Select or add an exam type.',
      createExamTypeFailed: 'Could not create the exam type. Please try again.',
      saveFailed: 'Could not save the exam. Check priority and try again.',
      saved: 'Exam saved successfully.',
      visitRequiredForExam: 'Select a saved visit (not only a calendar appointment) to prescribe exams.',
      priority: 'Priority',
      selectPriority: 'Select priority...',
      status: 'Status',
      selectStatus: 'Select status...',
      requestedDate: 'Requested Date',
      reason: 'Clinical Indication / Reason',
      reasonPlaceholder: 'Why is this exam needed? Clinical indication...',
      resultNotes: 'Result / Notes',
      resultNotesPlaceholder: 'Enter exam results or additional notes...',
      notesAutoCompleteStatus: 'Entering a result sets the status to Completed.',
      expectedCompletion: 'Expected Completion',
      updateExam: 'Update Exam',
      saveExam: 'Save Exam',
      deleteConfirm: 'Are you sure you want to delete this exam?',
      statuses: {
        ordered: 'Ordered',
        completed: 'Completed',
        pending: 'Pending',
      },
      priorities: {
        urgent: 'Urgent',
        routine: 'Routine',
        specific: 'Specific',
        most: 'Most',
      },
      types: {
        chestXray: 'Chest X-ray',
        glucose: 'Glucose',
        bloodCells: 'Blood cells',
        insulin: 'Insulin',
      },
    },
    prescriptions: {
      additionalNotesTitle: 'Additional Notes & Instructions',
      additionalNotesPlaceholder: 'Additional instructions, warnings, or notes for the patient...',
      drugWarningsTitle: 'Drug Interactions & Warnings',
      warningTitle: 'Warning title',
      warningDetail: 'Details / recommendation',
      addWarning: 'Add warning',
      noWarnings: 'No drug interaction warnings recorded for this visit.',
      saveNotes: 'Save notes & warnings',
      saving: 'Saving...',
      saved: 'Prescription notes and warnings saved.',
      saveFailed: 'Could not save prescription notes. Please try again.',
      visitRequired: 'Select a saved visit to add prescription notes.',
    },
    pendingExams: {
      title: 'Pending Exam Results',
      line: '{exam} from {date} — results still pending. Follow-up required.',
      followUp: 'Follow-up required.',
    },
    selectVisitPrompt: 'Select a visit from the timeline to view details',
    createFirstVisit: 'Create First Visit',
    common: {
      visit: 'Visit',
      unknownPatient: 'Unknown patient',
      doctor: 'Doctor',
      license: 'License',
      date: 'Date',
      history: 'History',
      client: 'Client',
      auth: 'Auth',
      preview: 'Preview',
      saveDraft: 'Save Draft',
      id: 'ID',
    },
    visitStatuses: {
      done: 'Done',
      confirmed: 'Confirmed',
      scheduled: 'Scheduled',
      cancelled: 'Cancelled',
      passed: 'Passed',
    },
    visitTypes: {
      review: 'Review Visit',
      emergency: 'Emergency Visit',
      followUp: 'Follow-up',
      consultation: 'Consultation',
    },
    appointment: {
      plannedTitle: 'Planned appointment',
      scheduledFromCalendar: 'Scheduled from calendar',
      routineCheckup: 'Routine checkup',
    },
    prescriptionTab: {
      title: 'Medical Prescription',
      prescriptionId: 'Prescription ID',
      validUntil: 'Valid until',
      patientInfo: 'Patient Information',
      clinicInfo: 'Clinic Information',
      clinicName: 'MedCenter Clinic',
      clinicAddress: '123 Health St, Medical City',
      addNewMedication: 'Add New Medication',
      addMedication: 'Add Medication',
      currentPrescriptions: 'Current Prescriptions',
      empty: 'No prescriptions yet. Add a medication to get started.',
      dosage: 'Dosage & amount',
      frequency: 'Frequency',
      duration: 'Duration',
      noInstructions: 'No instructions provided',
      printPrescription: 'Print Prescription',
      medicationStatuses: {
        active: 'Active',
        completed: 'Completed',
        cancelled: 'Cancelled',
        extended: 'Extended',
      },
      dialog: {
        editTitle: 'Edit Prescription',
        newTitle: 'Add New Prescription',
        medicationName: 'Medication Name',
        medicationPlaceholder: 'Enter medication name',
        dosage: 'Dosage & amount',
        dosagePlaceholder: 'e.g., 2.5 mg per dose · 20 tablets',
        dosageHelper: 'Include amount per dose and total to dispense (tablets, ml, etc.).',
        frequency: 'Frequency',
        frequencyPlaceholder: 'e.g., Once daily, every 12 hours, as needed',
        duration: 'Duration',
        durationPlaceholder: 'e.g., 7 days',
        instructions: 'Instructions',
        instructionsPlaceholder: 'Take with food...',
        extraNotes: 'Extra Notes',
        extraNotesPlaceholder: 'Additional notes...',
        status: 'Status',
        durationHistory: 'Duration History',
        durationHistoryPlaceholder: 'Previous duration changes...',
        cancel: 'Cancel',
        save: 'Save Prescription',
        update: 'Update Prescription',
        deleteConfirm: 'Are you sure you want to delete this prescription?',
        selectFrequency: 'Select frequency...',
        frequencyOnceDaily: 'Once daily',
        frequencyTwiceDaily: 'Twice daily',
        frequencyThreeDaily: 'Three times daily',
        frequencyFourDaily: 'Four times daily',
        frequencyAsNeeded: 'As needed',
        frequencyEveryOtherDay: 'Every other day',
        instructionsPlaceholder: 'Special instructions for taking this medication...',
        durationPlaceholderDays: 'e.g., 30 days',
        quantityPlaceholderShort: 'e.g., 30',
        savePrescription: 'Save Prescription',
        updatePrescription: 'Update Prescription',
      },
    },
    invoiceTab: {
      logoTitle: 'Medical Center Logo',
      uploadLogo: 'Upload clinic logo',
      logoFromSettings: 'Logo configured in System Settings',
      uploadLogoInSettings: 'Configure the logo in System Settings',
      clinicName: 'Clinic Name',
      address: 'Address',
      nitTaxId: 'NIT/Tax ID',
      invoiceDate: 'Invoice Date',
      invoiceInfo: 'Invoice Information',
      invoiceNumber: 'Invoice Number',
      dueDate: 'Due Date',
      patientInfo: 'Patient Information',
      fullName: 'Full Name',
      clientNit: 'Client NIT/ID',
      email: 'Email',
      phone: 'Phone',
      serviceDetails: 'Service Details',
      newInvoice: 'New Invoice',
      empty: 'No invoices yet. Create a new invoice to get started.',
      invoiceNumberShort: 'Invoice #{id}',
      dateLine: 'Date',
      nit: 'NIT',
      generateInvoice: 'Generate Invoice',
      summary: 'Invoice Summary',
      totalItems: 'Total Items',
      visitLabel: 'Visit',
      dialog: {
        editTitle: 'Edit Invoice',
        newTitle: 'New Invoice',
        createTitle: 'Create New Invoice',
        deleteConfirm: 'Are you sure you want to delete this invoice?',
        saveInvoice: 'Save Invoice',
        updateInvoice: 'Update Invoice',
        cancel: 'Cancel',
        description: 'Description',
        quantity: 'Quantity',
        unitPrice: 'Unit Price',
        discount: 'Discount %',
        paymentTerms: 'Payment Terms',
        notes: 'Notes',
        status: 'Status',
        headerTitle: 'Invoice Header',
        detailsTitle: 'Invoice Details',
        addItem: 'Add Item',
        total: 'Total',
        actions: 'Actions',
        subtotal: 'Subtotal',
        tax: 'Tax (8.5%)',
        grandTotal: 'Total',
        notesPlaceholder: 'Additional notes for the invoice...',
        invoiceStatuses: {
          draft: 'Draft',
          sent: 'Sent',
          paid: 'Paid',
          overdue: 'Overdue',
          cancelled: 'Cancelled',
        },
      },
    },
    errors: {
      saveVisit: 'Could not save visit. Please review the form values.',
      saveMedical: 'Could not save medical details.',
      uploadPhoto: 'Could not upload photo. Use an image under 2 MB.',
      removePhoto: 'Could not remove photo.',
    },
    form: {
      visitTitle: 'Visit Title',
      schedule: 'Schedule',
      nextAppointment: 'Next appointment date',
      nextAppointmentHint: 'A reminder email is sent 3 days before (if enabled).',
      editVisit: 'Edit Visit',
      newVisit: 'New Visit',
      optional: 'optional',
      requiredTitleSchedule: 'Visit title and schedule are required.',
      invalidSchedule: 'Schedule has an invalid date/time format.',
      clientRequired: 'Please select a client before saving the visit.',
      saveVisit: 'Save Visit',
      updateVisit: 'Update Visit',
    },
  },

  // Settings page
  settings: {
    companyLogo: 'Company Logo',
    companyLogoDescription: 'Upload your company logo to display it on budget PDFs and other documents. Recommended size: 200x200px. Maximum file size: 2MB.',
    selectLogo: 'Select Logo',
    uploadLogo: 'Upload Logo',
    removeLogo: 'Remove Logo',
    logoUploadedSuccess: 'Logo uploaded successfully!',
    logoRemovedSuccess: 'Logo removed successfully!',
    currencyUpdatedSuccess: 'Currency updated successfully!',
    currencySettings: 'Currency Settings',
    currencyDescription: 'Select the currency that will be displayed throughout the system for all monetary values.',
    currency: 'Currency',
    savingCurrency: 'Saving currency...',
    confirmRemoveLogo: 'Are you sure you want to remove the logo?',
    pleaseSelectImage: 'Please select an image file',
    fileSizeMax: 'File size must be less than 2MB',
    pleaseSelectLogo: 'Please select a logo file',
    failedUploadLogo: 'Failed to upload logo',
    failedUpdateCurrency: 'Failed to update currency',
    failedRemoveLogo: 'Failed to remove logo',
    themeSettings: 'Theme & colors',
    themeDescription: 'Set light/dark mode and brand colors for the whole app (menu, visits, invoices, etc.).',
    themeMode: 'Interface mode',
    themeModeLight: 'Light',
    themeModeDark: 'Dark',
    primaryColor: 'Primary color',
    secondaryColor: 'Secondary color',
    saveTheme: 'Save theme',
    savingTheme: 'Saving theme...',
    themeUpdatedSuccess: 'Theme updated. The interface now uses your colors.',
    failedUpdateTheme: 'Could not update theme.',
    clinicInfo: 'Clinic information',
    clinicInfoDescription: 'Shown on prescriptions and used as the default header for new invoices. Editing this does not change existing invoices.',
    clinicName: 'Clinic name',
    clinicAddress: 'Address',
    clinicPhone: 'Phone',
    clinicEmail: 'Email',
    clinicNit: 'Tax ID (NIT)',
    providerName: 'Doctor / prescriber name',
    providerNameHint: 'Leave blank to use the logged-in user name.',
    providerLicense: 'License number',
    saveClinic: 'Save clinic info',
    clinicUpdatedSuccess: 'Clinic information updated.',
    failedUpdateClinic: 'Could not update clinic information.',
    senderEmail: 'Sender email',
    senderEmailDescription: 'The "From" identity used for automated emails (reminders, birthdays). Superadmin only.',
    senderName: 'Sender name',
    senderEmailAddress: 'Sender email address',
    senderEmailHint: 'Must be verified in AWS SES before it is used as the real From address.',
    senderVerified: 'Address verified in SES',
    senderVerifiedHint: 'Turn on only after this address is confirmed verified in the AWS SES console. Until then, emails send from the app default and this address is used as Reply-To.',
    saveSender: 'Save sender email',
    senderUpdatedSuccess: 'Sender email updated.',
    failedUpdateSender: 'Could not update sender email.',
  },

  // Login
  login: {
    title: 'Techno',
    welcomeMessage: 'Welcome back! Please sign in to your account',
    emailAddress: 'Email Address',
    password: 'Password',
    signIn: 'Sign In',
    forgotPassword: 'Forgot your password?',
    resetPassword: 'Reset Password',
    enterEmailMessage: "Enter your email address and we'll send you a link to reset your password.",
    sendResetLink: 'Send Reset Link',
    passwordResetSuccess: 'Password reset link has been sent to your email address.',
    passwordResetError: 'Failed to send password reset email. Please try again.',
  },

  // Dashboard
  dashboard: {
    title: 'Dashboard',
    totalClients: 'Total Clients',
    servicesCompleted: 'Services Completed',
    totalIncome: 'Total Income',
    recentActivities: 'Recent Activities',
    thisMonth: 'This Month',
    lastMonth: 'Last Month',
    newCustomers: 'New Customers this month',
    moreServices: 'More Services',
    lessServices: 'Fewer Services',
    moreIncome: 'More Income',
    lessIncome: 'Less Income',
    nodata:'No data available',
    Welcome: 'Welcome back',
    msgwelcome:'Here is what is happening with Techno today.',
    msgchangeclients:'No change in clients this month',
    msgservicesame:'Same number of services completed this month',
    msgservicemore:'more services completed this month',
    msgservicefewer:'fewer services completed this month',
    msgincomesame:'Same revenue as last month',
    yourprofile:'Your Profile',
    yourroles: 'Your roles',
    keyp: 'Key Permissions',
  },

  // Clients
  clients: {
    title: 'Clients',
    searchPlaceholder: 'Search by name, phone, email, or any custom field…',
    clearSearch: 'Clear',
    showingClients: 'Showing {filtered} of {total} clients',
    noSearchResults: 'No clients match your search.',
    openCleaningDetails: 'Cleaning jobs for this client',
    client:'Client',
    addClient: 'Add New Client',
    editClient: 'Edit Client',
    deleteClient: 'Delete Client',
    clientName: 'Client Name',
    clientEmail: 'Client Email',
    clientPhone: 'Client Phone',
    lastVisit: 'Last visit',
    nextVisit: 'Next visit',
    addService: 'Add Service',
    serviceType: 'Service Type',
    serviceDate: 'Service Date',
    noClientsFound: 'No clients found',
    createFirstClient: 'Create your first client to get started',
    clientDetails: 'Client Details',
    customFields: 'Custom Fields',
    fieldConfiguration: 'Field Configuration',
    msjconffield:'Configure custom fields for client forms. These fields will appear when creating or editing clients.',
    addfield:'Add Field',
    namefield:'Name Field',
    Typefield: 'Type',
    emailfield:'Email',
    datefield: 'Date',
    actionsfield:'Actions',
    msjnoconffield:'No fields configured',
    msjaddfield:'Add your first custom field to get started',
    cancel: 'Cancel',
    csave:'Save',
    cupdate:'Update',
    condele:'Confirm Deletion',
    msgdele:'Are you sure you want to delete this client? This action cannot be undone.',
    vhistory:'Visit History',
    msjnovisit:'No visits found for this client.',
    addservadvform:'Add Service - Advanced Form',
    selecservice:'Select service...',
    value:'Value',
    sservice:'Save service',
    allclients:'All Clients',
    fields:'Fields',
    field:'Field',
    editField:'Edit Field',
    createField:'Create Field',
    updateField: 'Update Field',
    fieldLabel: 'Label',
    fieldType: 'Field type',
    options: 'Options',
    optionsPlaceholder: 'e.g. Small, Medium, Large',
    fieldDeletedSuccessfully:'Field deleted successfully (can be restored)',
    errorDeletingField:'Error deleting field',
    text: 'Text',
    number: 'Number',
    date: 'Date',
    deleteFieldConfirmation:'Are you sure you want to delete this field? This action cannot be undone.',
    deleteFieldSuccess:'Field deleted successfully',
    deleteFieldSuccessError:'Error deleting field',
    errorLoadingFields: 'Error loading fields',
    fieldUpdatedSuccess: 'Field updated successfully',
    fieldCreatedSuccess: 'Field created successfully',
    errorSavingField: 'Error saving field',
    sendAnniversaryEmail: 'Automatically email clients on this date using the selected template',
    requiredField: 'Required field',
    emailTemplate: 'Email template',
    emailTemplateRequired: 'Please select an email template for anniversary emails',
    noEmailTemplatesAvailable: 'No email templates available',
    anniversaryTemplate: 'Anniversary template',
    anniversaryEmailEnabled: 'Anniversary email enabled',
  },

  // Services
  services: {
    title: 'Services',
    serviceName: 'Service Name',
    addService: 'Add Service',
    editService: 'Edit Service',
    deleteService: 'Delete Service',
    deactivateService: 'Deactivate Service',
    activateService: 'Activate Service',
    noServicesFound: 'No services found',
    createFirstService: 'Create your first service to get started',
    serviceInformation: 'Service Information',
    confirmDeactivate: 'Are you sure you want to deactivate the service',
    confirmActivate: 'Are you sure you want to activate the service',
    deactivateMessage: 'This service will no longer appear in client forms.',
    activateMessage: 'This service will be available for client forms.',
    servicemanagment:'Service Management',
    msgsmanagment:'Manage and organize your services',
    searchsv:'Search Services...',
    tstatus:'Status',
    allstatus:'All Status',
    tactive:'Active',
    tinactive:'Inactive',
    clearfilters:'Clear Filters',
    sertype:'Service Types',
    msgnmservice:'Enter service name',
    previewservice:'Service Preview',
    msgdetailsSv:'Fill in the service details below',
    createNService:'Create New Service',
  },

  // Service History
  serviceHistory: {
    title: 'Service History',
    service: 'Service',
    client: 'Client',
    cost: 'Cost',
    noHistoryFound: 'No service history found',
    createFirstService: 'Complete your first service to see history here',
    msgtrack:'Track and manage service history records',
    searchHistory:'Search history...',
    allservice: 'All Services',
    allcients:'All Clients',
    today:'Hoy Today',
    tweek:"Esta Semana This Week",
    tmonth:"Este Mes This Month",
    clearfilters:'Clear Filters',
    createRecord:'Create Record',
    createHService:'Create Service History',
    msgcreateHService:'Service history created successfully!',
  },

  // Invoices
  invoices: {
    title: 'Invoices',
    invoiceNumber: 'Invoice Number',
    invoiceDate: 'Invoice Date',
    dueDate: 'Due Date',
    amount: 'Amount',
    status: 'Status',
    paid: 'Paid',
    pending: 'Pending',
    overdue: 'Overdue',
    addInvoice: 'Add Invoice',
    editInvoice: 'Edit Invoice',
    deleteInvoice: 'Delete Invoice',
    printInvoice: 'Print Invoice',
    noInvoicesFound: 'No invoices found',
    createFirstInvoice: 'Create your first invoice to get started',
    tinvoice: 'Invoice Management',
    msginvoice:'Manage and track all your invoices',
    sinvoice:'Search invoices...',
    Cancelled:'Cancelled',
    infoinvoice:'Invoice Information',
    createNewinvoice: 'Create New Invoice',
    msginfoInvoice:'Fill in the invoice information below',
    businessname:'Business name',
    businessaddress:'Business address',
    itemsinvoice:'Invoice Items',
    summaryInvoice:'Invoice Summary',
  },

  // Calendar
  calendar: {
    title: 'Calendar',
    appointments: 'Appointments',
    addAppointment: 'Add Appointment',
    editAppointment: 'Edit Appointment',
    deleteAppointment: 'Delete Appointment',
    noAppointments: 'No appointments scheduled',
    scheduleAppointment: 'Schedule your first appointment',

    pageTitle: 'Calendar Management',
    pageSubtitle: 'Manage appointments and schedules for your clinic',
    newAppointment: 'New Appointment',
    configure: 'Configure',
    refreshTooltip: 'Reload calendar and latest bookings',

    legend: {
      workingDay: 'Working Day',
      offDay: 'Off Day',
      partiallyBooked: 'Partially Booked',
      fullyBooked: 'Completely Booked'
    },

    days: {
      sun: 'Sun',
      mon: 'Mon',
      tue: 'Tue',
      wed: 'Wed',
      thu: 'Thu',
      fri: 'Fri',
      sat: 'Sat'
    },

    offDay: 'Off Day',
    availability: {
      available: 'available',
      booked: 'booked'
    },
    alerts: {
      offDay: 'This is an off day'
    },

    availableTimeSlots: 'Available Time Slots',
    bookedAppointments: 'Booked Appointments',
    secretaryQueue: 'Secretary queue: mark who has arrived and call late patients quickly.',
    noAvailableTimeSlots: 'No available time slots for this day',
    moreAppointments: 'Scroll to see more appointments...',

    selectClientForSlot: 'Select Client for {start} - {end}',
    client: 'Client',
    chooseClient: 'Choose a client...',
    searchClient: 'Search client by name, phone, or ID…',

    appointmentDetails: 'Appointment Details',
    scheduleNewAppointment: 'Schedule New Appointment',

    appointmentLabels: {
      unknownClient: 'Unknown Client',
      appointment: 'Appointment',
      unknown: 'Unknown',
      generalAppointment: 'General Appointment'
    },

    fields: {
      client: 'Client',
      phone: 'Phone',
      email: 'Email',
      visitType: 'Visit Type'
    },

    common: {
      na: 'N/A'
    },

    queue: {
      arrived: 'Arrived'
    },

    confirmation: {
      columnTitle: 'Confirmations',
      columnSubtitle: 'Confirm attendance before marking patient as arrived.',
      bulkSendWhatsapp: 'Send WhatsApp to all',
      bulkSendingWhatsapp: 'Sending...',
      title: 'Appointment confirmation',
      messageLabel: 'Message',
      useDefault: 'Use default message',
      confirmOnly: 'Confirm',
      confirmWhatsapp: 'Reminder via WhatsApp',
      confirmEmail: 'Reminder via email',
      emailSubject: 'Appointment confirmation',
      defaultMessage: 'Hi {patient}, your appointment is confirmed for {date} from {start} to {end}.',
      confirmedOnly: 'Appointment confirmed successfully.',
      sentToWhatsapp: 'Appointment confirmed and WhatsApp opened.',
      sentToEmail: 'Appointment confirmed and email client opened.',
      bulkWhatsappResult: 'Bulk WhatsApp ready: {success} opened, {failed} missing phone.',
      phoneRequiredForWhatsapp: 'Client phone is required to send WhatsApp confirmation.',
      emailRequired: 'Client email is required to send email confirmation.',
      errorConfirming: 'Could not confirm appointment.',
      errorBulkWhatsapp: 'Could not complete bulk WhatsApp send.',
      status: {
        confirmedOnly: 'Confirmed',
        whatsappSent: 'WhatsApp ready',
        emailSent: 'Email ready',
        whatsappFailed: 'WhatsApp not sent',
        emailFailed: 'Email not sent',
        confirmFailed: 'Confirmation failed'
      }
    },

    linkPublic: {
      badge: 'Public booking',
      hint: 'Link this booking to the correct patient record in your system.',
      selectPatient: 'Patient',
      choosePatient: 'Choose patient…',
      searchPatient: 'Type name, phone, or ID…',
      suggestedMatches: 'Suggested matches (name or phone)',
      linkButton: 'Link to patient',
      linking: 'Linking…',
      success: 'Appointment linked to patient.',
      error: 'Could not link appointment. Try again.',
      selectPatientFirst: 'Select a patient to link.',
      saveAsNewClientButton: 'Save as new client',
      saving: 'Saving…',
      savedAsNewClient: 'Saved as a new client and linked to this appointment.',
      saveAsNewClientError: 'Could not save as new client. Try again.',
      nameRequired: 'This booking has no name to create a client from.'
    },

    form: {
      creating: 'Creating...',
      cancel: 'Cancel',
      close: 'Close',
      cancelAppointment: 'Cancel Appointment',
      cancelConfirmTitle: 'Cancel appointment?',
      cancelConfirmMessage:
        'This will remove the appointment for {patient} on {date} ({time}). This action cannot be undone.',
      cancelConfirmAction: 'Yes, cancel appointment',
      cancelAppointmentSuccess: 'Appointment cancelled.',
      cancelAppointmentError: 'Could not cancel the appointment. Please try again.'
    },

    settings: {
      title: 'Calendar Settings',
      tabs: {
        weeklySchedule: 'Weekly Schedule',
        customDates: 'Custom Dates',
        publicBooking: 'Public booking'
      },
      publicBookingLanguage: 'Public booking page language',
      publicBookingLanguageHint:
        'Language shown on the public appointment link your patients use to book online.',
      languageEnglish: 'English',
      languageSpanish: 'Spanish',
      savePublicLanguage: 'Save language',
      publicLanguageSaved: 'Public booking language saved.',
      publicLanguageError: 'Could not save public booking language.',
      defaultWeeklySchedule: 'Default Weekly Schedule',
      weekday: 'Weekday',
      weekdays: {
        sunday: 'Sunday',
        monday: 'Monday',
        tuesday: 'Tuesday',
        wednesday: 'Wednesday',
        thursday: 'Thursday',
        friday: 'Friday',
        saturday: 'Saturday'
      },
      startTime: 'Start Time',
      endTime: 'End Time',
      status: 'Status',
      saveSchedule: 'Save Schedule',
      scheduleSaved: 'Weekly schedule saved.',
      scheduleError: 'Could not save weekly schedule. Check the times and try again.',
      scheduleEndBeforeStart: 'End time must be after start time.',
      currentWeeklyConfig: 'Current Weekly Configuration',
      customDateOverrides: 'Custom Date Overrides',
      overrideDefaultSchedules:
        'Set hours for a single date. Bookings use this schedule for that day only; all other days keep the weekly schedule.',
      overrideDate: 'Date',
      saveOverride: 'Save date override',
      removeOverride: 'Remove override',
      noOverrides: 'No custom date overrides yet.',
      overrideSaved: 'Custom schedule saved for this date.',
      overrideRemoved: 'Custom schedule removed. This date will use the weekly schedule again.',
      overrideDateRequired: 'Please select a date.',
      overrideError: 'Could not save the custom schedule. Please try again.',
      overrideDeleteError: 'Could not remove the override. Please try again.',
      existingOverrides: 'Saved overrides',
      defaultForWeekday: 'Weekly default for this day: {status} · {range}',
      clickToEdit: 'Click to edit'
    },

    dialog: {
      scheduleNewAppointmentTitle: 'Schedule New Appointment',
      clientRequired: 'Client *',
      dateRequired: 'Date *',
      startTimeRequired: 'Start Time *',
      endTimeRequired: 'End Time *',
      visitIdOptional: 'Visit ID (Optional)',
      visitLinkPlaceholder: 'Link to existing visit',
      createAppointment: 'Create Appointment',
      errors: {
        fillRequiredFields: 'Please fill in all required fields',
        errorCreatingAppointment: 'Error creating appointment'
      }
    },
    public: {
      openPublicView: 'Public booking view',
      title: 'Book Your Appointment',
      titleDefault: 'Appointment booking',
      titleWithDoctor: '{name} — appointment booking',
      subtitle: 'Choose an available slot and reserve your appointment.',
      tenantHint:
        'Shared link: add ?tenantId=YOUR_CLINIC_ID to the URL if the schedule does not load (your clinic will provide this).',
      selectDate: 'Select date',
      offDay: 'No bookings available on this day.',
      noSlots: 'There are no available slots for this day.',
      bookThisSlot: 'Book this slot',
      bookDialogTitle: 'Book appointment',
      newPatientName: 'Your name',
      newPatientEmail: 'Email',
      newPatientPhone: 'Phone number',
      contactHint: 'Email and phone are optional but recommended.',
      nameRequired: 'Please enter your name.',
      saveAsNewClient: 'Create a new patient record in the clinic (optional)',
      confirmBooking: 'Confirm booking',
      bookingSuccess: 'Your appointment was booked successfully.',
      bookingError: 'Could not book your appointment. Please try again.',
      loadError: 'Could not load public schedule.',
      networkError:
        'Could not reach the server (network/CORS). Ensure the API is running (e.g. port 8080), restart Laravel after CORS changes, and hard-refresh the page.'
    }
  },

  cleaningSchedule: {
    title: 'Schedule',
    client: 'Client',
    day: 'Day',
    week: 'Week',
    month: 'Month',
    today: 'Today',
    timeTeam: 'Time / team',
    filterClient: 'Client',
    filterCleaner: 'Cleaner',
    all: 'All',
    dailyCapacity: 'Daily capacity',
    capacityWarning: 'Approaching max capacity',
    capacityFull: 'At or near full capacity',
    unassigned: 'Unassigned jobs',
    unassignedWeekHint: 'All open slots in this week (any day).',
    noneUnassigned: 'No unassigned jobs this week.',
    slots: 'slots',
    autoSchedule: 'Auto-schedule remaining',
    assignWho: 'Assign to…',
    assignMultipleTitle: 'Assign cleaners',
    assignMultipleHint: 'Select one or more cleaners for this job on this date.',
    assignAddCleanerTitle: 'Add another cleaner',
    assignAddCleanerHint:
      'Only employees who are not already on this job that day are listed. Tap names to select, then save.',
    assignAddCleanerTooltip: 'Add cleaner',
    assignAddNoOneAvailable:
      'No one else can be added (everyone is already assigned to this job that day, or the list is filtered).',
    shiftTeamHint:
      'Removes only this day’s calendar assignment for that person (the cleaning job itself is unchanged).',
    shiftRemoveOne: 'Remove from this day',
    cardDialogTypeProjected: 'On team — not on calendar this day',
    cardDialogTypeScheduled: 'Scheduled',
    cardDialogCleanersSection: 'On this shift',
    cardDialogAddCleaner: 'Add another cleaner',
    cardDialogUnassignedHelp:
      'This visit still needs someone assigned for this day. Choose who should work it.',
    cardDialogProjectedHelp:
      '{name} is linked to this job but does not have a calendar assignment for this day yet.',
    cardDialogPlaceOnCalendar: 'Place on calendar for this day',
    cardDialogProjectedAddCleanerHint:
      'Use “{name}” above to put the linked cleaner on the calendar. To schedule someone else for this job on this day, use Add another cleaner.',
    cardDialogLinkedCleanerFallback: 'the linked cleaner',
    cardDialogAssign: 'Assign cleaners',
    cardDialogEditJob: 'Open job to edit details',
    cardDialogTotalHours: 'Total hours (job): {hours} h',
    cardDialogHoursPerPerson:
      'Each cleaner on site about {each} h ({total} h job ÷ {count} people).',
    cardDialogFullWindow: 'Full job window on the schedule: {start}–{end}',
    fullJobWindowNote: 'Full visit through {end}',
    tooltipScheduledMulti:
      '{client} · Each on site {eachStart}–{eachEnd} ({each} h, {count} people) · Booking through {jobEnd}',
    assignSave: 'Assign selected',
    assignPickOne: 'Select at least one cleaner.',
    assignScopeTitle: 'How should this assignment apply?',
    assignScopeDescription:
      'This job repeats. Add this person to the job team for future visits (they will appear on later dates), or assign them only for this visit without joining the permanent team for other dates.',
    assignScopeDescriptionOneOff:
      'This visit is a one-day job (no repeating series). Confirm to add the calendar assignment for this date only.',
    assignScopeWholeSeries: 'Whole series — job team',
    assignScopeThisVisit: 'This visit only',
    assignScopeConfirmOneOff: 'Assign for this date',
    recurringConflictTitle: 'Possible conflicts on future dates',
    recurringConflictIntro:
      'Adding this cleaner to the whole series means they are expected on every future occurrence of this job. They already have overlapping assignments on other jobs on the dates below.',
    recurringConflictThisJobWindow: 'This job’s time window: {start}–{end}',
    recurringConflictOtherJob: 'Other job: {client} ({start}–{end})',
    recurringConflictGoBack: 'Go back',
    recurringConflictAssignAnyway: 'Assign to whole series anyway',
    recurringConflictPreviewError: 'Could not check for future conflicts. Try again or choose “This visit only”.',
    selected: 'Selected',
    tapToSelect: 'Tap',
    assignedPartial: 'Assigned {ok}, failed {fail}',
    loadError: 'Could not load schedule',
    assigned: 'Assignment saved',
    assignError: 'Could not create assignment',
    removed: 'Assignment removed',
    removeError: 'Could not remove assignment',
    add: 'Add',
    addOnDemandForClient: 'Add on-demand job for selected client',
    addNewClientOnDemand: 'Add new client + on-demand job',
    onDemandTitle: 'Create on-demand job',
    onDemandInfo:
      'This will be created as a one-day schedule so it appears on this calendar (it will not repeat).',
    onDemandFillRequired: 'Please select a client, date, hours, and hourly rate.',
    onDemandCreated: 'On-demand job created',
    onDemandCreateError: 'Could not create on-demand job',
    serviceDate: 'Service date',
    startTime: 'Start time',
    hours: 'Hours',
    hourlyRate: 'Hourly rate',
    wages: 'Wages',
    notes: 'Notes',
    availableCleaners: 'Available cleaners',
    availableCleanersHint: 'Not currently scheduled on the selected day.',
    noneAvailable: 'No available cleaners for this day.',
    dailyCapacityHint:
      'Capacity uses each employee’s weekly hours (settings) when set; otherwise their “max hours per day” from the employee profile.',
    cleanersHoursHint: 'Shows all active cleaners and how many hours they’re assigned on the selected day.',
    assignedHoursLabel: 'Assigned today: {hours} h',
    totalAssignedHoursLabel: 'Total job hours today: {hours} h',
    dayPendingTooltip: 'This day has unassigned jobs or visits that need attention.',
    dayPendingAria: 'Pending items on this day',
    offFullDayLabel: 'Unavailable (full day off)',
    attentionWeekCount: '{count} visit(s) need attention',
    attentionDayTitle: 'Needs attention today',
    attentionDayHint: 'Cleaner is marked off or partially unavailable when this job runs.',
    attentionTooltip: 'Needs attention (time off)',
    availabilityDialogTitle: 'Calendar capacity & time off',
    availabilityDialogTooltip: 'Weekly hours per cleaner and dates off',
    availabilityDialogIntro:
      'Set how many hours each person is available per weekday (team capacity). Add dates off so overlapping jobs stand out on the schedule.',
    availabilityTabWeekly: 'Weekly hours',
    availabilityTabTimeOff: 'Time off',
    availabilityPickEmployee: 'Employee',
    availabilityDow1: 'Monday (hours)',
    availabilityDow2: 'Tuesday (hours)',
    availabilityDow3: 'Wednesday (hours)',
    availabilityDow4: 'Thursday (hours)',
    availabilityDow5: 'Friday (hours)',
    availabilityDow6: 'Saturday (hours)',
    availabilityDow7: 'Sunday (hours)',
    availabilitySaveWeekly: 'Save weekly hours',
    availabilityWeeklySaved: 'Weekly availability saved',
    availabilityTimeOffHint:
      'Time off is for this tenant only. Jobs that overlap an absence are highlighted and listed under “Needs attention”.',
    availabilityTimeOffListTitle: 'This week',
    availabilityTimeOffEmpty: 'No time off entries this week.',
    availabilityAddTimeOffSection: 'Add time off',
    availabilitySubmitTimeOff: 'Save time off',
    availabilityFullDay: 'Full day off',
    availabilityTimeStart: 'From',
    availabilityTimeEnd: 'To',
    availabilityReason: 'Reason (optional)',
    availabilityTimeOffAdded: 'Time off saved',
    availabilityTimeOffRemoved: 'Time off removed',
    availabilityLoadError: 'Could not load availability settings',
    noneActiveCleaners: 'No active cleaners.',
  },

  cleaningDetails: {
    title: 'Cleaning jobs',
    new: 'New cleaning job',
    edit: 'Edit cleaning job',
    client: 'Client',
    addClient: 'Add client',
    addClientTitle: 'New client',
    clientName: 'Name',
    clientPhone: 'Phone',
    clientEmail: 'Email',
    clientNameRequired: 'Client name is required.',
    clientCreated: 'Client created',
    clientCreateError: 'Could not create client',
    recurrence: 'Schedule',
    recurrenceOptional: 'Schedule (optional)',
    recurrenceFieldHelp:
      'Link a repeating rule for this job (e.g. Every 2 weeks + start date + time), or leave On demand and place visits manually on the calendar.',
    onDemandNoSchedule: 'On demand (no recurring schedule)',
    schedule: 'Schedule',
    newSchedule: 'New schedule',
    createSchedule: 'Create schedule',
    copyDefaultsFromScheduled: 'Copy hours/rate from scheduled job',
    copiedDefaults: 'Defaults copied (saved as on-demand)',
    noScheduledDefaults: 'No scheduled job found for this client.',
    copyDefaultsError: 'Could not copy defaults',
    scheduleType: 'Repeat',
    daily: 'Daily',
    weekly: 'Weekly',
    everyNWeeks: 'Every N weeks (weekday)',
    monthly: 'Monthly',
    everyWeeksInterval: 'Every (weeks)',
    everyNWeeksHelp:
      'Same weekday every N weeks. The pattern starts on the first matching weekday on or after the start date (0 = Sun … 6 = Sat).',
    scheduleEveryNWeeks: 'Every {n} weeks',
    everyDays: 'Every (days)',
    dayOfWeek: 'Day of week (0 Sun – 6 Sat)',
    dayOfWeekHelp: '0 = Sunday, 1 = Monday, … 6 = Saturday',
    dayOfMonth: 'Day of month',
    startDate: 'Start date',
    endDate: 'End date (optional)',
    startTime: 'Start time',
    notes: 'Notes',
    horas: 'Hours',
    hourlyRate: 'Hourly rate',
    income: 'Income',
    wages: 'Wages',
    team: 'Team',
    cleaners: 'Cleaners (team)',
    addCleaners: 'Add cleaners',
    cleanersDialogTitle: 'Add people to this job',
    cleanersSearchPlaceholder: 'Search by name…',
    cleanersPickerEmpty: 'No matching employees left to add (or everyone is already on the team).',
    cleanersPlaceholder: 'Search names, click to add several',
    totalHoursHelper: 'Total time on site for this job (used for billing and scheduling).',
    openSchedule: 'Open cleaning schedule',
    scheduleHint:
      'This form defines the job (client, hours, team, billing). Use the cleaning schedule to add each visit (day, time, cleaners).',
    cleanersHelper:
      'Select one or more employees for this job. Removing someone here removes their calendar assignments for this job (tracks are deleted with their cleaner link).',
    actions: 'Actions',
    none: 'No cleaning jobs yet.',
    filteredByClient: 'Filtered by client',
    deleteTitle: 'Delete cleaning job',
    deleteConfirm: 'Delete this cleaning job? Related assignments may be removed.',
    loadError: 'Could not load cleaning jobs',
    saveError: 'Could not save',
    createdSuccess: 'Cleaning job created',
    updatedSuccess: 'Cleaning job updated',
    deletedSuccess: 'Cleaning job deleted',
    deleteError: 'Could not delete',
    recurrenceCreated: 'Schedule created',
    recurrenceError: 'Could not create schedule',
    selectSchedulePlaceholder: 'Select a schedule…',
    selectScheduleRequired:
      'Choose a schedule from the list, or use "+ New schedule" to create one. Hours and rate are not enough on their own.',
    fillRequired: 'Please select a client and enter hours and hourly rate.',
  },

  // Forms
  forms: {
    required: 'This field is required',
    invalidEmail: 'Please enter a valid email address',
    invalidPhone: 'Please enter a valid phone number',
    minLength: 'Must be at least {min} characters',
    maxLength: 'Must be no more than {max} characters',
    invalidDate: 'Please enter a valid date',
    invalidTime: 'Please enter a valid time',
    invalidNumber: 'Please enter a valid number',
    invalidUrl: 'Please enter a valid URL',
    passwordsDoNotMatch: 'Passwords do not match',
    weakPassword: 'Password must be at least 8 characters long'
  },

  // Messages
  messages: {
    saveSuccess: 'Saved successfully',
    updateSuccess: 'Updated successfully',
    deleteSuccess: 'Deleted successfully',
    createSuccess: 'Created successfully',
    saveError: 'Failed to save',
    updateError: 'Failed to update',
    deleteError: 'Failed to delete',
    createError: 'Failed to create',
    loadError: 'Failed to load data',
    networkError: 'Network error. Please check your connection.',
    unauthorized: 'You are not authorized to perform this action',
    notFound: 'The requested resource was not found',
    serverError: 'Server error. Please try again later.',
    validationError: 'Please check the form for errors'
  },

  // Inventory & Sales
  inventory: {
    origin: {
      customer: 'Customer',
      supplier: 'Supplier',
      other: 'Other'
    }
  },
  sales: {
    title: 'Sales',
    newSale: 'New Sale',
    editSale: 'Edit Sale',
    customer: 'Customer',
    noCustomer: 'No Customer',
    originCustomer: 'Customer',
    search: 'Search...',
    product: 'Product',
    allProducts: 'All Products',
    client: 'Client',
    allClients: 'All Clients',
    location: 'Location',
    allLocations: 'All Locations',
    date: 'Date',
    quantity: 'Quantity',
    unitPrice: 'Unit Price',
    total: 'Total',
    notes: 'Notes',
    actions: 'Actions',
    noSalesFound: 'No sales found',
    date: 'Date',
    additionalNotes: 'Additional notes about this sale',
    totalSaleAmount: 'Total Sale Amount',
    errorLoadingSales: 'Error loading sales',
    saleDeletedSuccess: 'Sale deleted successfully and kardex entry removed',
    errorDeletingSale: 'Error deleting sale',
    errorLoadingSale: 'Error loading sale',
    pleaseSelectLocation: 'Please select a location',
    pleaseAddProduct: 'Please add at least one product to the sale',
    saleRegisteredSuccess: 'Sale registered successfully with {count} item(s)',
  },

  // Tenant Management
  tenantManagement: {
    title: 'Tenant Management',
    createTenant: 'Create Tenant',
    editTenant: 'Edit Tenant',
    createTenantDescription: 'Create a new tenant (company) for the multi-tenant Techno system.',
    editTenantDescription: 'Edit tenant information and settings.',
    companyName: 'Company Name',
    subdomain: 'Subdomain',
    customDomain: 'Custom Domain',
    nit: 'NIT (Tax ID)',
    address: 'Address',
    plan: 'Plan',
    status: 'Status',
    createdAt: 'Created At',
    noTenants: 'No tenants found',
    searchPlaceholder: 'Search tenants...',
    filterByStatus: 'Filter by Status',
    filterByPlan: 'Filter by Plan',
    allStatuses: 'All Statuses',
    allPlans: 'All Plans',
    basic: 'Basic',
    professional: 'Professional',
    enterprise: 'Enterprise',
    profile: 'Profile',
    profileDefault: 'Default',
    profileSchool: 'School',
    profileLoyalty: 'Loyalty program',
    profileMenu: 'Digital menu',
    active: 'Active',
    trial: 'Trial',
    suspended: 'Suspended',
    cancelled: 'Cancelled',
    suspend: 'Suspend',
    activate: 'Activate',
    visit: 'Visit',
    stats: 'Statistics',
    usersCount: 'Users',
    clientsCount: 'Clients',
    budgetsCount: 'Budgets',
    servicesCount: 'Services',
    visitsCount: 'Visits',
    appointmentsCount: 'Appointments',
    invoicesCount: 'Invoices',
    storageUsed: 'Storage Used',
    lastActivity: 'Last Activity',
    email: 'Email',
    phone: 'Phone',
    subdomainHint: 'Only lowercase letters, numbers, and hyphens',
    customDomainHint: 'Your custom domain (e.g., techno.mycompany.com)',
    invalidSubdomain: 'Invalid subdomain format. Use only lowercase letters, numbers, and hyphens.',
    tenantCreatedSuccess: 'Tenant created successfully',
    errorCreatingTenant: 'Error creating tenant',
    tenantUpdatedSuccess: 'Tenant updated successfully',
    errorUpdatingTenant: 'Error updating tenant',
    tenantSuspendedSuccess: 'Tenant suspended successfully',
    errorSuspendingTenant: 'Error suspending tenant',
    tenantActivatedSuccess: 'Tenant activated successfully',
    errorActivatingTenant: 'Error activating tenant',
    errorLoadingTenants: 'Error loading tenants',
  },

  tenantRoles: {
    title: 'Tenant Roles',
    description: 'Select which roles each tenant can assign to their users. When creating users for a tenant, only these roles will appear.',
    selectTenant: 'Select tenant',
    rolesForTenant: 'Roles for this tenant',
    rolesHint: 'Check the roles that this tenant can assign to its users.',
    assigned: 'Assigned',
    savedSuccess: 'Tenant roles saved successfully',
    errorLoading: 'Error loading data',
    errorLoadingRoles: 'Error loading tenant roles',
    errorSaving: 'Error saving tenant roles',
    noTenants: 'No tenants found. Create a tenant first.',
  },

  // Budgets
  budgets: {
   title: 'Budgets',
   totalbudgets: 'Total Budgets',
   draft: 'draft',
   approved: 'Approved',
   totalValue:'Total Value',
   newBudget: 'New Budget',
   srBudget:'Search budgets...',
   all:'All',
   sent:'Sent',
   rejected:'Rejected',
   msgnobudgetfound:'No budgets found',
   deletebudget:'Delete Budget',
   msgdeletebudget:'Are you sure you want to delete this budget?',
   editBudget: 'Edit Budget',
   nameBudget:'Budget Name',
   valid:'Valid Until',
   description:'Description',
   BudgetItems:'Budget Items',
   quantity:'Quantity',
   unit:'Unit',
   unitPrice:'Unit Price',
   selectUnit:'Select unit',
   view: 'View',
   edit: 'Edit',
   send: 'Send',
   sendNow: 'Send Now',
   sendLabel: 'Send',
   emailRecipients: 'Email Recipients',
   recipientName: 'Recipient Name {n}',
   recipientEmail: 'Recipient Email {n}',
   approvedOn: 'Approved On',
   noClient: 'No client',
   sendToClient: 'Send to client ({email})',
   sendBudgetViaEmail: 'Send Budget via Email',
   sendDialogDescription: 'Select or add the email addresses that should receive this budget.',
   emailNumber: 'Email {n}',
   emailPlaceholder: 'email@example.com',
   remove: 'Remove',
   addRecipient: 'Add recipient',
   messageOptional: 'Message (optional)',
   emailTemplateHint: 'The email already includes a greeting (Hello,) and closing (Thank you.). Your message will appear in between.',
   storeNewEmails: 'Store new emails for future use',
   updateStatusToSent: 'Update status to Sent',
   exportPdf: 'Export PDF',
   exportExcel: 'Export Excel',
   budgetUnits: 'Budget Units',
   manageUnits: 'Manage the measurement units available for budgets. Only active units appear here.',
   refresh: 'Refresh',
   newUnit: 'New Unit',
   editBudgetUnit: 'Edit Budget Unit',
   newBudgetUnit: 'New Budget Unit',
   active: 'Active',
   saving: 'Saving...',
   nameRequired: 'Name is required',
   budgetUnitUpdated: 'Budget unit updated',
   budgetUnitCreated: 'Budget unit created',
   budgetUnitInactive: 'Budget unit set to inactive',
   errorLoadingUnits: 'Error loading budget units',
   errorSavingUnit: 'Error saving budget unit',
   errorUpdatingUnit: 'Error updating budget unit',
   noActiveUnits: 'No active budget units found.',
   markInactive: 'Mark Inactive',
   setInactiveConfirm: 'Set "{name}" as inactive?',
   budgetTypes: 'Budget Types',
   manageTypes: 'Manage the available budget types. Only active types appear here.',
   newType: 'New Type',
   addNewType: 'Add new type...',
   addNewUnit: 'Add new unit...',
   editBudgetType: 'Edit Budget Type',
   newBudgetType: 'New Budget Type',
   budgetTypeUpdated: 'Budget type updated',
   budgetTypeCreated: 'Budget type created',
   budgetTypeInactive: 'Budget type set to inactive',
   errorLoadingTypes: 'Error loading budget types',
   errorSavingType: 'Error saving budget type',
   errorUpdatingType: 'Error updating budget type',
   noActiveTypes: 'No active budget types found.',
   errorLoadingBudgets: 'Error loading budgets',
   budgetDeletedSuccess: 'Budget deleted successfully',
   errorDeletingBudget: 'Error deleting budget',
   exportedSuccess: '{type} exported successfully',
   errorExporting: 'Error exporting {type}',
   pleaseProvideEmail: 'Please provide at least one email address',
   budgetSentSuccess: 'Budget sent successfully',
   errorSendingBudget: 'Error sending budget',
   errorLoadingBudgetTypes: 'Error loading budget types',
   errorLoadingBudgetUnits: 'Error loading budget units',
   errorLoadingClients: 'Error loading clients',
   errorLoadingBudget: 'Error loading budget',
   budgetMustHaveItem: 'Budget must have at least one item',
   pleaseFillAllItemFields: 'Please fill all required fields in all items',
   budgetUpdatedSuccess: 'Budget updated successfully',
   budgetCreatedSuccess: 'Budget created successfully',
 },
 // Products
 products: {
  title: 'Products',
  newProduct: 'New Product',
  editProduct: 'Edit Product',
  deleteProduct: 'Delete Product',
  noProductsFound: 'No products found',
  createFirstProduct: 'Create your first product to get started',
  productInformation: 'Product Information',
  confirmDeletion: 'Are you sure you want to delete this product?',
  searchProducts: 'Search products...',
  image: 'Image',
  name: 'Name',
  price: 'Price',
  actions: 'Actions',
  productName: 'Product Name',
  ProductImage: 'Product Image',
  PriceHelperText: 'Enter amount with up to 2 decimal places',
  imageHelperText: 'Recommended: 800x800px or 1024x1024px (square format)',
  imageDimensionsTooltip: 'For best results, use square images (1:1 ratio) with dimensions between 800x800px and 1024x1024px. Maximum file size: 10MB.',
  deleteProductConfirmation:'Are you sure you want to delete this product? This action cannot be undone.',
  deleteProductSuccess:'Product deleted successfully',
  deleteProductSuccessError:'Error deleting product',
  productDeletedSuccessfully:'Product deleted successfully (can be restored)',
  errorDeletingProduct:'Error deleting product',
  Tracking:'Tracking',
  errorLoadingProducts: 'Error loading products',
  productDeletedSuccess: 'Product deleted successfully',
  errorDeletingProductSnackbar: 'Error deleting product',
  errorLoadingProduct: 'Error loading product',
  pleaseFillRequiredFields: 'Please fill in all required fields',
  pleaseEnterValidPrice: 'Please enter a valid price',
  productUpdatedSuccess: 'Product updated successfully',
  productCreatedSuccess: 'Product created successfully',
 },
 // Locations
  // Loyalty program
  menus: {
    dash: {
      pickMenu: 'Menu',
      editMenu: 'Edit menu',
      errorLoading: 'Could not load your menu',
      ordersToday: 'Orders today',
      soldToday: 'Sold today',
      visits: 'Menu visits',
      visitsHint: 'All time',
      pendingTitle: 'Orders to confirm',
      noPending: 'No orders waiting. New ones show up here on their own.',
      morePending: '{count} more in All orders',
      allOrders: 'All orders',
      topToday: 'Best sellers today',
      noSalesToday: 'No confirmed orders yet today.',
      availabilityTitle: 'Dishes on the menu',
      soldOutCount: '{count} sold out',
      noDishes: 'No dishes yet. Add them from Edit menu.',
    },
    title: 'Digital menu',
    subtitle: "Build your restaurant's menu and share it with a link or QR code.",
    newMenu: 'New menu',
    create: 'Create menu',
    restaurantName: 'Restaurant name',
    restaurantNameHint: 'Shown on the menu. You can change it later.',
    emptyTitle: 'Your first digital menu',
    emptyHint: 'Add sections, dishes with photos and prices, and share a link your guests open on their phone.',
    published: 'Published',
    draft: 'Draft',
    dishCount: '{count} dishes',
    sectionCount: '{count} sections',
    views: '{count} views',
    copyLink: 'Copy link',
    copy: 'Copy',
    linkCopied: 'Link copied',
    linkUpdated: 'Link updated',
    openMenu: 'View menu',
    preview: 'Preview',
    openPreview: 'Open preview',
    notPublishedYet: 'Publish the menu to open the link',
    backToMenus: 'Back to menus',
    draftHint: 'This menu is a draft: only you can see it through the preview. Turn on "Published" when it is ready.',
    draftHintReadOnly: 'This menu is not published yet.',
    nowPublished: 'Menu published! You can share the link now.',
    nowUnpublished: 'Menu unpublished: the link is no longer available.',
    tabDishes: 'Dishes',
    tabDesign: 'Design',
    tabInfo: 'Information',
    tabShare: 'Share',
    tabOrders: 'Orders',
    pendingBeforeOne: '1 order from earlier days is still waiting to be confirmed.',
    pendingBefore: '{count} orders from earlier days are still waiting to be confirmed.',
    showPending: 'Show',
    pendingOrdersCount: '{count} to confirm',
    errorLoadingOrders: 'Could not load the orders',
    ordersOffHint: 'Orders arrive when a diner taps "Order on WhatsApp". Turn on WhatsApp orders under Info to receive them.',
    range: { today: 'Today', yesterday: 'Yesterday', week: '7 days', month: '30 days', custom: 'Custom' },
    rangeFrom: 'From',
    rangeTo: 'To',
    refresh: 'Refresh',
    statOrders: 'Orders',
    statSold: 'Sold',
    statSoldHint: '{count} confirmed · average ticket {avg}',
    orderStatus: { pending: 'To confirm', confirmed: 'Confirmed', cancelled: 'Cancelled' },
    allStatuses: 'All',
    viewOrders: 'Orders',
    viewProducts: 'Products sold',
    customer: 'Customer',
    orderNumber: 'Order',
    orderTime: 'Date',
    orderItems: 'Dishes',
    orderTotal: 'Total',
    status: 'Status',
    orderDetail: 'Show detail',
    confirmOrder: 'Confirm',
    cancelOrder: 'Cancel',
    cancelOrderConfirm: 'Cancel order #{number}?',
    confirmedBy: 'Confirmed by {name} · {time}',
    cancelledBy: 'Cancelled by {name} · {time}',
    noOrders: 'No orders on these dates.',
    product: 'Product',
    quantity: 'Qty',
    unitPrice: 'Price',
    amount: 'Amount',
    timesSold: 'Sold',
    inOrders: 'Orders',
    productsHint: 'Only confirmed orders count.',
    noProductsSold: 'No confirmed sales on these dates yet.',
    rowsPerPage: 'Per page',
    livePreview: 'Phone preview',
    errorLoading: 'Could not load the menu',
    errorSaving: 'Could not save the changes',
    saved: 'Changes saved',
    deleted: 'Deleted',
    unsavedChanges: 'You have unsaved changes',
    allSaved: 'All saved',
    discard: 'Discard',
    saveChanges: 'Save changes',

    // Sections & dishes
    newSection: 'New section',
    editSection: 'Edit section',
    deleteSection: 'Delete section',
    sectionName: 'Section name',
    sectionNamePlaceholder: 'Starters, Mains, Drinks…',
    sectionDescription: 'Section note (optional)',
    sectionDescriptionPlaceholder: 'Served until 11:30, includes a drink…',
    sectionEmpty: 'No dishes in this section yet.',
    noSectionsTitle: 'Start with a section',
    noSectionsHint: 'Organise your menu into sections like Breakfast, Mains or Drinks, then add the dishes.',
    deleteSectionConfirm: 'Delete "{name}" and its {count} dishes?',
    hideSection: 'Hide section from the menu',
    showSection: 'Show section on the menu',
    hidden: 'Hidden',
    dragToReorder: 'Drag to reorder',
    addDish: 'Add dish',
    newDish: 'New dish',
    editDish: 'Edit dish',
    deleteDish: 'Delete dish',
    deleteDishConfirm: 'Delete "{name}"?',
    dishName: 'Dish name',
    dishDescription: 'Description',
    dishDescriptionHint: 'Ingredients, sides, portion size…',
    section: 'Section',
    priceSingle: 'One price',
    priceOptions: 'Sizes / options',
    price: 'Price',
    priceHint: 'Leave empty for market price.',
    optionLabel: 'Option',
    addOption: 'Add option',
    removeOption: 'Remove option',
    sizeSmall: 'Small',
    sizeLarge: 'Large',
    from: 'from',
    tags: 'Tags',
    tag: {
      popular: 'Favourite',
      new: 'New',
      chef: "Chef's pick",
      spicy: 'Spicy',
      vegetarian: 'Vegetarian',
      vegan: 'Vegan',
      gluten_free: 'Gluten free',
    },
    dishPhotoHint: 'A good photo sells more · square or landscape',
    available: 'Available',
    availableShort: 'Available',
    availableHint: 'Turn it off when it runs out: shown as "Sold out".',
    soldOut: 'Sold out',
    markSoldOut: 'Mark as sold out',
    markAvailable: 'Mark as available',
    nowSoldOut: '{name}: sold out',
    nowAvailable: '{name}: available',
    featured: 'Featured',
    featuredHint: 'Shown with a large photo.',
    visible: 'Visible on the menu',
    visibleHint: 'Turn it off to hide it without deleting it.',

    // Design
    photos: 'Photos',
    photosHint: 'The cover stays with your guests while they read the menu.',
    cover: 'Cover',
    coverHint: 'Portrait photo of your place or signature dish',
    logo: 'Logo',
    logoHint: 'PNG with transparent background',
    color: 'Brand colour',
    colorHint: 'Used for the striped awning, buttons and the guest’s picks.',
    customColor: 'Colour',
    style: 'Style',
    theme: 'Background',
    themeLight: 'Light',
    themeDark: 'Dark',
    font: 'Typeface',
    font_slab: 'Classic',
    font_slab_hint: 'Warm and readable, diner and café.',
    font_serif: 'Elegant',
    font_serif_hint: 'For restaurants and bistros.',
    font_sans: 'Modern',
    font_sans_hint: 'Clean, for cafés and quick service.',
    imageAdd: 'Add photo',
    imageHint: 'PNG, JPG or WebP',
    imageReplace: 'Replace',
    imageRemove: 'Remove photo',
    imageInvalid: 'Please choose an image file.',
    imageTooLarge: 'The image is too large (max 12 MB).',

    // Info
    restaurant: 'Restaurant',
    tagline: 'Short tagline',
    taglinePlaceholder: 'Wood-fired Guatemalan cooking since 1998',
    about: 'Our story',
    aboutPlaceholder: 'Tell your guests who you are…',
    aboutHint: 'Leave a blank line between paragraphs.',
    contact: 'Contact and location',
    phone: 'Phone',
    whatsappHint: 'Include the country code if not a Guatemalan number.',
    whatsappOrders: 'Take orders on WhatsApp',
    whatsappOrdersHint: 'Guests build their picks on the menu and send them to you on WhatsApp.',
    email: 'Email',
    address: 'Address',
    mapsUrl: 'Google Maps link (optional)',
    mapsUrlHint: 'If empty, the address is searched on Google Maps.',
    hours: 'Opening hours',
    hoursPlaceholder: 'Tuesday to Sunday\n7:00 – 22:00',
    social: 'Social media',
    website: 'Website',

    // Share
    publicLink: 'Public link',
    publicLinkHint: 'Share it on social media, WhatsApp or Google. No login needed.',
    slug: 'Customise link',
    slugHint: 'Lowercase letters, numbers and dashes only.',
    slugWarning: 'Changing the link breaks QR codes that are already printed.',
    qrTitle: 'QR code',
    qrHint: 'For tables, the counter or the door.',
    downloadQr: 'Download',
    printCard: 'Print table card',
    printScan: 'Scan to see our menu',
    deleteMenu: 'Delete menu',
    deleteMenuHint: 'All sections, dishes and photos are deleted. The link and QR stop working.',
    deleteMenuConfirm: 'Delete the menu "{name}"? This cannot be undone.',
  },
  loyalty: {
    cashierTitle: 'Loyalty cashier',
    dashboardTitle: 'Loyalty program',
    findCustomer: 'Find customer',
    scanOrSearch: 'Scan QR or enter phone',
    scanPlaceholder: 'QR code or phone number',
    scanHint: 'Scan the customer QR (UUID) or type the phone and press Enter.',
    customerNotFound: 'Customer not found in the loyalty program.',
    notMemberYet: 'This customer is not a member of your program yet. The first purchase will enroll them.',
    enroll: 'Enroll',
    enrollCustomer: 'Enroll customer',
    clientEnrolled: 'Customer enrolled',
    firstName: 'First name',
    lastName: 'Last name',
    phoneHint: 'Guatemala (+502) is assumed when no country code is given.',
    viewProfile: 'View profile',
    currentPoints: 'Current points',
    lifetimePoints: 'Lifetime points',
    totalSpent: 'Total spent',
    visits: 'Visits',
    firstVisit: 'First visit',
    lastVisit: 'Last visit',
    birthday: 'Birthday',
    location: 'Location',
    singleLocationHint: 'Only location — preselected',
    registerPurchase: 'Register purchase',
    purchaseTotal: 'Purchase total',
    reference: 'Reference (ticket / invoice)',
    pointsEarned: 'Points earned',
    rule: 'Rule',
    points: 'points',
    purchaseRegistered: 'Purchase registered successfully',
    newBalance: 'New balance',
    redeemReward: 'Redeem reward',
    rewardRedeemed: 'Reward redeemed',
    redeem: 'Redeem',
    noRewards: 'No rewards configured.',
    members: 'Loyalty members',
    searchMembers: 'Search by name, phone or email…',
    noMembers: 'No members yet',
    transactions: 'Transactions',
    pointsActivity: 'Points activity',
    rewardsRedeemed: 'Rewards redeemed',
    type: 'Type',
    cashier: 'Cashier',
    customer: 'Customer',
    change: 'Change',
    balanceBefore: 'Before',
    balanceAfter: 'After',
    by: 'By',
    reward: 'Reward',
    pointsSpent: 'Points spent',
    adjustPoints: 'Adjust points',
    adjustHint: 'Positive adds points, negative removes points.',
    pointsAdjusted: 'Points adjusted',
    rewards: 'Rewards',
    newReward: 'New reward',
    editReward: 'Edit reward',
    pointsRequired: 'Points required',
    validity: 'Validity',
    redemptions: 'redemptions',
    startsAt: 'Starts at',
    endsAt: 'Ends at',
    rewardSaved: 'Reward saved',
    rewardDeleted: 'Reward deleted',
    deleteRewardConfirm: 'Delete this reward?',
    all: 'All',
    from: 'From',
    to: 'To',
    refund: 'Refund',
    refunded: 'Purchase refunded',
    refundConfirm: 'Refund this purchase? The earned points will be removed from the customer balance.',
    settings: 'Loyalty settings',
    settingsSubtitle: 'Set how your members earn points and what they see in the app.',
    programActive: 'Program active',
    programInactive: 'Program inactive',
    programSettings: 'Program settings',
    enableProgram: 'Enable loyalty program',
    enableHint: 'Shows the loyalty dashboard on the home page.',
    pointsPerCurrency: 'Points per currency unit',
    pointsPerCurrencyHint: 'Example: 1 = every Q1 spent earns 1 point.',
    birthdayBonus: 'Birthday bonus points',
    birthdayBonusHint: "0 = off. Gifted once a year on the member's birthday (needs birthday on profile).",
    settingsSaved: 'Settings saved',
    promotions: 'Promotions & news',
    promotionsSubtitle: 'Posts your members see in the Mi Lealtad app.',
    newPromotion: 'New post',
    editPromotion: 'Edit post',
    promotionTypePromo: 'Promo',
    promotionTypeAnnouncement: 'Announcement',
    promotionTitle: 'Title',
    promotionTitlePlaceholder: 'Your headline here',
    promotionBody: 'Message',
    audience: 'Who sees it',
    audienceMembers: 'Members only',
    audiencePublic: 'Everyone',
    audienceMembersHint: 'Shown in the news feed and business page of enrolled customers.',
    audiencePublicHint: 'Also shown on your business page to app users who are not members yet.',
    promotionPublish: 'Published',
    promotionPreview: 'Preview in the app',
    promotionEndsOn: 'Until {date}',
    promotionNoEnd: 'No end date',
    promotionSaved: 'Post saved',
    promotionDeleted: 'Post deleted',
    deletePromotionConfirm: 'Delete this post? Customers will stop seeing it.',
    noPromotions: 'No posts yet',
    noPromotionsHint: 'Share a promo, new product or schedule change with your members.',
    promotionUsage: '{used} of {max} active posts',
    promotionLimitHint: 'Limit of {max} active posts reached. You can still save a draft.',
    promotionFilterAll: 'All',
    promotionFilterEnded: 'Ended / off',
    promotionStatus: { live: 'Live', scheduled: 'Scheduled', expired: 'Ended', inactive: 'Off' },
    imageAdd: 'Add a photo (optional)',
    imageHint: 'PNG, JPG or WebP · up to 4 MB · shown in the customer app',
    imageSize: 'Recommended size: 1200 × 600 px (landscape). Keep the main subject centered; edges may be cropped in the app.',
    imageReplace: 'Replace',
    imageRemove: 'Remove photo',
    imageInvalid: 'Please choose an image file.',
    imageTooLarge: 'Image must be 4 MB or smaller.',
    enabledByProfile: 'Always on for tenants with the Loyalty program profile.',
    earningRules: 'Earning rules',
    birthdayBonusOn: '🎂 +{points} pts on their birthday',
    birthdayBonusOff: 'Off',
    birthdayBonusSchedule: 'Granted automatically every morning at 8:00 to members with a birthday on their profile.',
    previewTitle: 'What your members get',
    previewPurchase: 'Q100 purchase = {points} pts',
    previewPurchaseSub: 'Earned at checkout when they show their code',
    previewBirthday: '{points} pts birthday gift',
    previewBirthdaySub: 'Once a year, automatically',
    previewBirthdayOff: 'No birthday gift',
    previewBirthdayOffSub: 'Set points above to surprise members',
    previewRewards: 'Rewards catalogue',
    previewRewardsSub: 'Manage in Loyalty → Rewards',
    previewDisabled: "Program is off — members can't earn points yet.",
    birthdayToday: '🎂 Birthday today!',
    errorLoading: 'Error loading loyalty data',
    errorSaving: 'Error saving',
    active30d: 'Active 30d',
    newThisMonth: 'New this month',
    revenueThisMonth: 'Revenue this month',
    purchases: 'purchases',
    avgTicket: 'avg ticket',
    vsLastMonth: 'vs last month',
    pointsIssuedThisMonth: 'Points issued this month',
    outstanding: 'Outstanding',
    pointsRedeemedThisMonth: 'Points redeemed this month',
    redemptionRate: 'redemption rate',
    trend: 'Last 6 months',
    revenue: 'Revenue',
    pointsIssued: 'Points issued',
    pointsRedeemed: 'Points redeemed',
    topRewards30d: 'Top rewards (30 days)',
    noRedemptionsYet: 'No redemptions yet',
    topMembers: 'Top members',
    recentActivity: 'Recent points activity',
    noActivityYet: 'No activity yet',
    ledgerTypes: {
      POINTS_EARNED: 'Points earned',
      REWARD_REDEMPTION: 'Reward redemption',
      MANUAL_ADJUSTMENT: 'Manual adjustment',
      BONUS: 'Bonus',
      REFUND: 'Refund',
      POINTS_EXPIRED: 'Points expired',
    },
  },
 locations: {
  title: 'Locations',
  newLocation: 'New Location',
  editLocation: 'Edit Location',
  deleteLocation: 'Delete Location',
  noLocationsFound: 'No locations found',
  createFirstLocation: 'Create your first location to get started',
  locationInformation: 'Location Information',
  searchLocations: 'Search locations...',
  name: 'Name',
  address: 'Address',
  phone: 'Phone',
  actions: 'Actions',
  deletedLocation: 'Location deleted successfully',
  errorDeletingLocation: 'Error deleting location',
  deleteConfirmation: 'Are you sure you want to delete this location?',
  errorLoadingLocations: 'Error loading locations',
  errorLoadingLocation: 'Error loading location',
  locationUpdatedSuccess: 'Location updated successfully',
  locationCreatedSuccess: 'Location created successfully',
 },
 // Origins
 origins: {
  title: 'Origins',
  newOrigin: 'New Origin',
  editOrigin: 'Edit Origin',
  deleteOrigin: 'Delete Origin',
  noOriginsFound: 'No origins found',
  createFirstOrigin: 'Create your first origin to get started',
  originInformation: 'Origin Information',
  searchOrigins: 'Search origins...',
  name: 'Name',
  code: 'Code',
  description: 'Description',
  status: 'Active',
  actions: 'Actions',
  helperText: 'A unique code for programmatic reference (e.g., "customer", "supplier")',
  nameRequiredHelper: 'At least one name (English or Spanish) is required',
  errorLoadingOrigin: 'Error loading origin',
  pleaseFillOneName: 'Please fill in at least one name (English or Spanish)',
  originUpdatedSuccess: 'Origin updated successfully',
  originCreatedSuccess: 'Origin created successfully',
  errorLoadingOrigins: 'Error loading origins',
  originDeletedSuccess: 'Origin deleted successfully',
  errorUpdatingOrigin: 'Error updating origin',
 },
 // Providers
 providers: {
  title: 'Providers',
  newProvider: 'New Provider',
  editProvider: 'Edit Provider',
  deleteProvider: 'Delete Provider',
  noProvidersFound: 'No providers found',
  createFirstProvider: 'Create your first provider to get started',
  providerInformation: 'Provider Information',
  confirmDeletion: 'Are you sure you want to delete this provider?',
  searchProviders: 'Search providers...',
  name: 'Name',
  code: 'Code',
  email: 'Email',
  phone: 'Phone',
  address: 'Address',
  description: 'Description',
  status: 'Active',
  actions: 'Actions',
  helperText: 'A unique code for programmatic reference',
  nameRequiredHelper: 'At least one name (English or Spanish) is required',
  errorLoadingProviders: 'Error loading providers',
  providerDeletedSuccess: 'Provider deleted successfully',
  providerUpdatedSuccess: 'Provider updated successfully',
  errorUpdatingProvider: 'Error updating provider',
  errorLoadingProvider: 'Error loading provider',
  pleaseFillProviderName: 'Please fill in the provider name',
  providerCreatedSuccess: 'Provider created successfully',
 },
 // Inventories
 inventories: {
  title: 'Inventory (Kardex)',
  newInventory: 'New Inventory',
  editInventory: 'Edit Inventory',
  deleteInventory: 'Delete Inventory',
  noInventoriesFound: 'No inventories found',
  createFirstInventory: 'Create your first inventory to get started',
  inventoryInformation: 'Inventory Information',
  searchInventories: 'Search inventories...',
  NewBuy: 'New Buy',
  NewSell: 'New Sell',
  Buy: 'Buy',
  Sell: 'Sell',
  Date: 'Date',
  Type: 'Type',
  Tracking: 'Tracking',
  Product: 'Product',
  Location: 'Location',
  Quantity: 'Quantity',
  UnitPrice: 'Unit Price',
  Total: 'Total',
  TransactionTotal: 'Transaction Total',
  StockTotal: 'Stock Total',
  RemainingInventory: 'Remaining Inventory',
  AvailableInventory: 'Available Inventory',
  InsufficientInventory: 'Insufficient inventory',
  Origin: 'Origin',
  Provider: 'Provider',
  NoProvider: 'No Provider',
  Attachment: 'Attachment',
  Actions: 'Actions',
  New: 'New',
  SelectProduct: 'Select Product',
  NoLocation: 'No Location',
  NoOrigin: 'No Origin',
  Notes: 'Notes',
  Transaction: 'Transaction',
  NoTransactionsFound: 'No transactions found',
  Date: 'Date',
  Type: 'Type',
  Product: 'Product',
  Location: 'Location',
  Quantity: 'Quantity',
  UnitPrice: 'Unit Price',
  Total: 'Total',
  Origin: 'Origin',
  Attachment: 'Attachment',
  Actions: 'Actions',
  errorLoadingInventories: 'Error loading inventories',
  transactionDeletedSuccess: 'Transaction deleted successfully',
  errorDeletingTransaction: 'Error deleting transaction',
  errorLoadingTransaction: 'Error loading transaction',
  quantityRequired: 'Quantity is required',
  unitPriceRequired: 'Unit price is required',
  quantityMustBeValid: 'Quantity must be a valid positive number',
  unitPriceMustBeValid: 'Unit price must be a valid non-negative number',
  productRequired: 'Product is required',
  transactionUpdatedSuccess: 'Transaction updated successfully',
  transactionCreatedSuccess: 'Transaction created successfully',
 },
 reports: {
  title: 'Reports',
  chooseReport: 'Choose a report to view metrics and charts.',
  openReport: 'Open report',
  sectionInventorySales: 'Inventory & Sales',
  sectionPayments: 'Payments',
  sectionClinic: 'Clinic',
  sectionCleaning: 'Cleaning & scheduling',
  sectionSchool: 'School',
  attendanceStudentSummary: 'Student attendance summary',
  attendanceStudentSummaryDescription:
    'Per student over a date range: present, absent, late, and days without a mark.',
  attendanceSchoolWide: 'School-wide',
  attendanceUnmarked: '{count} unmarked days (total)',
  attendanceUnmarkedDays: 'Unmarked days',
  attendanceDaysInRange: '{count} days in range',
  attendanceStatusFilter: 'Show students',
  attendanceStatusAll: 'All students',
  attendanceStatusPresent: 'With present days',
  attendanceStatusAbsent: 'With absences',
  attendanceStatusLate: 'With late arrivals',
  attendanceStatusUnmarked: 'With unmarked days',
  attendanceShowingCount: 'Showing {count} of {total} students',
  attendanceNoStudentsForFilter: 'No students match this filter.',
  clinicAppointmentBookings: 'Appointment bookings',
  clinicAppointmentBookingsDescription:
    'Bookings in a date range: total count, confirmed patients who showed up, confirmed no-shows (past dates), and cancellations. Mark arrivals on the calendar so show-up counts stay accurate.',
  clinicTotalBookings: 'Total bookings',
  clinicConfirmedShowedUp: 'Confirmed & showed up',
  clinicConfirmedNoShow: 'Confirmed, did not show',
  clinicConfirmedUpcoming: 'Confirmed, upcoming',
  clinicCancelled: 'Cancelled',
  clinicPending: 'Pending (not confirmed)',
  clinicChartTitle: 'Bookings overview',
  clinicPendingCount: 'Pending: {count}',
  clinicUpcomingCount: 'Upcoming confirmed: {count}',
  productInventory: 'Product & Inventory',
  totalSales: 'Total Sales',
  salesByProduct: 'Sales by Product',
  earningsByBatch: 'Earnings by Batch',
  productInventoryDescription: 'View current inventory levels for all products',
  totalSalesDescription: 'View total sales statistics and trends',
  salesByProductDescription: 'View sales breakdown by product',
  earningsByBatchDescription: 'View profit analysis by batch (buy price vs sell price)',
  product: 'Product',
  currentInventory: 'Current Inventory',
  remainingInventory: 'Remaining Inventory',
  totalBuyQuantity: 'Total Buy Quantity',
  totalBuyValue: 'Total Buy Value',
  totalSellQuantity: 'Total Sell Quantity',
  totalSellValue: 'Total Sell Value',
  trackingMethod: 'Tracking Method',
  totalSalesAmount: 'Total Sales Amount',
  totalQuantity: 'Total Quantity',
  totalTransactions: 'Total Transactions',
  salesByDate: 'Sales by Date',
  date: 'Date',
  transactions: 'Transactions',
  saleCount: 'Sale Count',
  buyDate: 'Buy Date',
  revenue: 'Revenue',
  cost: 'Cost',
  profit: 'Profit',
  profitMargin: 'Profit Margin',
  totalRevenue: 'Total Revenue',
  totalCost: 'Total Cost',
  totalProfit: 'Total Profit',
  startDate: 'Start Date',
  endDate: 'End Date',
  filter: 'Filter',
  reset: 'Reset',
  searchProducts: 'Search products...',
  noData: 'No data available',
  errorLoading: 'Error loading data',

  paymentsActiveMembershipsByMonth: 'Active memberships by month',
  paymentsActiveMembershipsByMonthDescription: 'Total active memberships per month (last 12 months).',
  activeMembershipsThisMonth: 'Active memberships this month: {count}',

  paymentsActiveClientsCounts: 'Clients with active memberships',
  paymentsActiveClientsCountsDescription: 'Total clients with active memberships and how many each one has.',
  totalActiveClients: 'Active clients: {count}',
  totalActiveMemberships: 'Active memberships: {count}',
  activeMemberships: 'Active memberships',

  paymentsIncomeByDateRange: 'Income by date range',
  paymentsIncomeByDateRangeDescription: 'Total income from membership payments in a date range.',
  totalIncome: 'Total income',

  cleaningHoursWagesByCleaner: 'Cleaner hours & wages',
  cleaningHoursWagesByCleanerDescription:
    'Each row is one cleaner on one job that day. Hours shown are the job’s scheduled hours divided by how many cleaners are on that job that day (same split as job wages). Hourly wages use that share × the cleaner’s rate; job wages split the job total across those cleaners.',
  cleaningHoursByClient: 'Job hours by client',
  cleaningHoursByClientDescription:
    'Hours worked per client per day. Each job is counted once per day (not multiplied by number of cleaners).',
  cleaningCleaner: 'Cleaner',
  cleaningClient: 'Client',
  cleaningHours: 'Hours',
  cleaningJobName: 'Job name',
  cleaningDaySubtotal: 'Day subtotal',
  cleaningTotalHours: 'Total hours',
  cleaningWagesByHourly: 'Wages (hourly × hours)',
  cleaningWagesByJob: 'Wages (job ÷ cleaners that day)',
  cleaningTabDetail: 'By day',
  cleaningTabByCleaner: 'By cleaner (totals)',
  cleaningTabByClient: 'By client (totals)',
  cleaningFilterByCleaner: 'Filter by cleaner',
  cleaningFilterAllCleaners: 'All cleaners',
  cleaningChartHoursByDay: 'Total hours per day (all cleaners)',
  cleaningChartWagesByDay: 'Total wages per day (all cleaners)',
  cleaningChartPayByCleaner: 'Total to pay per cleaner (range)',
  cleaningChartPayByCleanerHint: 'Bar height uses the wage basis selected below.',
  cleaningWageBasisLabel: 'Basis for "Total to receive" (by cleaner tab)',
  cleaningWageBasisHourly: 'Hourly × hours',
  cleaningWageBasisJob: 'Share of job wage',
  cleaningAmountToReceive: 'Total to receive (range)',
  cleaningHoursByDayChart: 'Total job hours per day (all clients)',
 },
 sales: {
  title: 'Sales',
  newSale: 'New Sale',
  editSale: 'Edit Sale',
  date: 'Sale Date',
  unitPrice: 'Unit Price',
  totalSaleAmount: 'Total Sale Amount',
  notes: 'Notes',
  additionalNotes: 'Additional notes or comments',
 },
 students: {
  title: 'Students',
  newStudent: 'New Student',
  editStudent: 'Edit Student',
  updateStudent: 'Update Student',
  saveStudent: 'Save Student',
  studentName: 'Student Name',
  studentCode: 'Student Code',
  studentCodeHelper: 'Unique identifier for the student.',
  deleteStudent: 'Delete Student',
  noStudentsFound: 'No students found',
  createFirstStudent: 'Create your first student to get started',
  studentInformation: 'Student Information',
  searchStudents: 'Search students...',
  deletedStudents: 'Deleted Students',
  searchPlaceholder: 'Search students by name or code...',
  code: 'Code',
  createdAt: 'Created At',
  bulkAssignGrade: 'Bulk Assign Grade',
  assignGrade: 'Assign Grade',
  deleteStudentTitle: 'Delete Student',
  deleteStudentConfirm: 'Are you sure you want to delete this student? This action can be undone.',
  assignGradeTitle: 'Assign Grade to {name}',
  bulkAssignGradeTitle: 'Bulk Assign Grade to {count} Student(s)',
  grade: 'Grade',
  cycle: 'Cycle',
  selectBothGradeCycle: 'Please select both grade and cycle',
  selectAtLeastOne: 'Please select at least one student',
  gradeAssignedSuccess: 'Grade assigned to student successfully',
  gradeAssignedBulkSuccess: 'Grade assigned to {count} student(s) successfully',
  assignedWithErrors: 'Assigned to {successCount} student(s), {errorCount} failed',
  errorAssigningGrade: 'Error assigning grade to student',
  errorAssigningGrades: 'Error assigning grades',
  studentDeletedSuccess: 'Student deleted successfully',
  errorDeletingStudent: 'Error deleting student',
  errorLoadingStudents: 'Error loading students',
  moreActions: 'More actions',
  assignGradeToAll: 'Assign to All',
  bulkAssignDescription: 'This will assign the selected grade and cycle to all {count} selected student(s).',
  searchDeletedPlaceholder: 'Search deleted students by name or code...',
  deletedAt: 'Deleted At',
  noDeletedStudentsFound: 'No deleted students found',
  restoreStudent: 'Restore Student',
  restoreStudentTitle: 'Restore Student',
  restoreStudentConfirm: 'Are you sure you want to restore {name}?',
  studentRestoredSuccess: 'Student restored successfully',
  errorRestoringStudent: 'Error restoring student',
  errorLoadingDeletedStudents: 'Error loading deleted students',
  errorLoadingStudent: 'Error loading student',
  studentUpdatedSuccess: 'Student updated successfully',
  studentCreatedSuccess: 'Student created successfully',
 },
 employees: {
  title: 'Employees',
  newEmployee: 'New employee',
  editEmployee: 'Edit employee',
  deleteEmployee: 'Delete employee',
  noEmployeesFound: 'No employees found',
  searchEmployees: 'Search employees...',
  confirmDeletion: 'Are you sure you want to delete this employee?',
  name: 'Name',
  email: 'Email',
  phone: 'Phone',
  role: 'Role',
  status: 'Status',
  hourlyRate: 'Hourly rate',
  overtimeRate: 'Overtime rate',
  maxHoursPerDay: 'Max hours / day',
  maxHoursPerWeek: 'Max hours / week',
  color: 'Calendar color',
  hireDate: 'Hire date',
  actions: 'Actions',
  roleCleaner: 'Cleaner',
  roleSupervisor: 'Supervisor',
  roleAdmin: 'Admin',
  statusActive: 'Active',
  statusInactive: 'Inactive',
  errorLoadingEmployees: 'Error loading employees',
  errorLoadingEmployee: 'Error loading employee',
  errorDeletingEmployee: 'Error deleting employee',
  employeeDeletedSuccess: 'Employee deleted successfully',
  employeeUpdatedSuccess: 'Employee updated successfully',
  employeeCreatedSuccess: 'Employee created successfully',
  pleaseFillName: 'Please enter the employee name',
  invalidHourlyRate: 'Please enter a valid hourly rate',
  invalidHours: 'Please enter valid max hours',
  invalidOvertimeRate: 'Please enter a valid overtime rate',
 },
 cycles: {
  title: 'Cycles',
  newCycle: 'New Cycle',
  deletedCycles: 'Deleted Cycles',
  searchPlaceholder: 'Search cycles by name...',
  searchDeletedPlaceholder: 'Search deleted cycles by name...',
  name: 'Name',
  createdAt: 'Created At',
  deletedAt: 'Deleted At',
  noCyclesFound: 'No cycles found',
  noDeletedCyclesFound: 'No deleted cycles found',
  deleteCycleTitle: 'Delete Cycle',
  deleteCycleConfirm: 'Are you sure you want to delete this cycle? This action can be undone.',
  cycleDeletedSuccess: 'Cycle deleted successfully',
  errorDeletingCycle: 'Error deleting cycle',
  errorLoadingCycles: 'Error loading cycles',
  restoreCycle: 'Restore Cycle',
  restoreCycleTitle: 'Restore Cycle',
  restoreCycleConfirm: 'Are you sure you want to restore {name}?',
  cycleRestoredSuccess: 'Cycle restored successfully',
  errorRestoringCycle: 'Error restoring cycle',
  errorLoadingDeletedCycles: 'Error loading deleted cycles',
  editCycle: 'Edit Cycle',
  updateCycle: 'Update Cycle',
  saveCycle: 'Save Cycle',
  cycleName: 'Cycle Name',
  cycleUpdatedSuccess: 'Cycle updated successfully',
  cycleCreatedSuccess: 'Cycle created successfully',
  errorLoadingCycle: 'Error loading cycle',
  pleaseFillRequired: 'Please fill in all required fields',
 },
 grades: {
  title: 'Grade Levels',
  newGrade: 'New Grade',
  deletedGrades: 'Deleted Grades',
  searchPlaceholder: 'Search grades by name...',
  searchDeletedPlaceholder: 'Search deleted grades by name...',
  name: 'Name',
  createdAt: 'Created At',
  deletedAt: 'Deleted At',
  noGradesFound: 'No grades found',
  noDeletedGradesFound: 'No deleted grades found',
  deleteGradeTitle: 'Delete Grade',
  deleteGradeConfirm: 'Are you sure you want to delete this grade? This action can be undone.',
  gradeDeletedSuccess: 'Grade deleted successfully',
  errorDeletingGrade: 'Error deleting grade',
  errorLoadingGrades: 'Error loading grades',
  restoreGrade: 'Restore Grade',
  restoreGradeTitle: 'Restore Grade',
  restoreGradeConfirm: 'Are you sure you want to restore {name}?',
  gradeRestoredSuccess: 'Grade restored successfully',
  errorRestoringGrade: 'Error restoring grade',
  errorLoadingDeletedGrades: 'Error loading deleted grades',
  editGrade: 'Edit Grade',
  updateGrade: 'Update Grade',
  saveGrade: 'Save Grade',
  gradeName: 'Grade Name',
  gradeUpdatedSuccess: 'Grade updated successfully',
  gradeCreatedSuccess: 'Grade created successfully',
  errorLoadingGrade: 'Error loading grade',
  pleaseFillRequired: 'Please fill in all required fields',
 },
 planifications: {
  title: 'Planifications',
  typesButton: 'Types',
  deleted: 'Deleted',
  new: 'New',
  searchPlaceholder: 'Search by name or type...',
  emptyList: 'No planifications found. Create one with "New" or add a child under an existing planification.',
  addChild: 'Add child planification',
  send: 'Send',
  downloadPdf: 'Download PDF',
  deleteTitle: 'Delete Planification',
  deleteConfirm: 'Are you sure you want to delete {name}?',
  restoreTitle: 'Restore Planification',
  restoreTypeTitle: 'Restore Type',
  restoreConfirm: 'Are you sure you want to restore {name}?',
  statusDraft: 'draft',
  statusSent: 'sent',
  statusInReview: 'In Review',
  statusNeedsChanges: 'Needs Changes',
  statusApproved: 'approved',
  typesTitle: 'Planification Types',
  newType: 'New Type',
  searchTypes: 'Search types...',
  noTypesFound: 'No planification types found.',
  deleteTypeTitle: 'Delete Planification Type',
  deleteTypeConfirm: 'Are you sure you want to delete {name}?',
  deleteTypeConfirmSoft: 'This is a soft delete. You can restore it from the deleted list.',
  addChildType: 'Add child type',
  child: 'Child',
  root: 'Root',
  editPlanification: 'Edit Planification',
  newPlanification: 'New Planification',
  typeOfPlanification: 'Type of planification',
  selectTypePlaceholder: 'Select type (Bimestral, semanal, Diaria…)',
  typeHelper: 'Choose what kind of planification this is (e.g. Bimestral, semanal, Diaria).',
  infoSelectType: 'Select the type of planification (e.g. Bimestral, semanal, Diaria) for this plan. You can also add a child by clicking "Add" on a row in the list.',
  typeSelectedBelow: 'Type: {name} (you can change it below)',
  parentPlanification: 'Parent planification',
  noneTopLevel: 'None (top level)',
  parentHelper: 'Only top-level planifications are listed. Set one so this appears nested under it in the list.',
  shareWith: 'Share with',
  shareWithHelp: 'Add users who can view or edit this planification. They will see it in their list.',
  addUser: 'Add user',
  permissionView: 'View',
  permissionEdit: 'Edit',
  permissionLabel: 'Permission',
  noAssignedUsers: 'No users assigned yet. Add someone so they can see this planification.',
  alreadyAssigned: 'This user is already assigned.',
  assignmentsNotAvailable: 'Assignments are not available. Run migrations to enable sharing.',
  assignmentsSaved: 'Assignments saved.',
  parentHelperCreate: 'This planification will be created under: {name}. Choose the type (e.g. semanal, Diaria) for this child below.',
  startReview: 'Start Review',
  needsChanges: 'Needs Changes',
  approve: 'Approve',
  attachmentsTitle: 'Attachments (Planification)',
  upload: 'Upload',
  noAttachments: 'No attachments yet.',
  startDate: 'Start Date',
  endDate: 'End Date',
  saveSection: 'Save Section',
  content: 'Content',
  sectionAttachments: 'Section Attachments',
  uploadFilesPlanification: 'Upload files for the whole planification.',
  noSectionAttachments: 'No section attachments.',
  comments: 'Comments',
  noCommentsYet: 'No comments yet.',
  addComment: 'Add comment',
  setNeedsChanges: 'Set Needs Changes',
  add: 'Add',
  reviewer: 'Reviewer',
  curso: 'Curso',
  cursoOptional: 'Optional. Link this planification to a course.',
  deletedPlanificationsTitle: 'Deleted Planifications',
  deletedTypesTitle: 'Deleted Planification Types',
  searchDeleted: 'Search deleted planifications by name...',
  searchDeletedTypes: 'Search deleted types by name...',
  noDeletedFound: 'No deleted planifications found',
  noDeletedTypesFound: 'No deleted planification types found',
  deletedAt: 'Deleted At',
  restore: 'Restore',
  errorLoadingPlanificationTypes: 'Error loading planification types',
  planificationTypeDeletedSuccess: 'Planification type deleted successfully',
  errorDeletingPlanificationType: 'Error deleting planification type',
  errorLoadingPlanificationType: 'Error loading planification type',
  planificationTypeUpdated: 'Planification type updated',
  planificationTypeCreated: 'Planification type created',
  errorLoadingPlanifications: 'Error loading planifications',
  planificationSent: 'Planification sent',
  pdfDownloadedSuccess: 'PDF downloaded successfully',
  planificationDeleted: 'Planification deleted',
  errorDeletingPlanification: 'Error deleting planification',
  errorLoadingPlanification: 'Error loading planification',
  planificationUpdated: 'Planification updated',
  planificationCreated: 'Planification created',
  typeRequired: 'Type is required',
  statusUpdated: 'Status updated',
  sectionSaved: 'Section saved',
  errorSavingSection: 'Error saving section',
  commentRequired: 'Comment is required',
  commentAdded: 'Comment added',
  errorAddingComment: 'Error adding comment',
  fileUploaded: 'File uploaded',
  errorUploadingFile: 'Error uploading file',
  editPlanificationType: 'Edit Planification Type',
  newPlanificationType: 'New Planification Type',
  parentOptional: 'Parent (optional)',
  none: 'None',
  sections: 'Sections',
  addSection: 'Add Section',
  noSectionsYet: 'No sections yet. Add as many text sections as you need.',
  sectionName: 'Section Name',
  defaultTextOptional: 'Default Text (optional)',
  sectionNumber: 'Section {number}',
  moveUp: 'Move up',
  moveDown: 'Move down',
  remove: 'Remove',
 },
 permissions: {
  errorLoadingPermissions: 'Error loading permissions',
  permissionUpdatedSuccess: 'Permission updated successfully',
  permissionCreatedSuccess: 'Permission created successfully',
  permissionDeletedSuccess: 'Permission deleted successfully',
  errorDeletingPermission: 'Error deleting permission',
 },
 support: {
  title: 'Support Request',
  problemLabel: 'What problem are you experiencing?',
  problemPlaceholder: 'Please describe the issue you\'re facing...',
  urlLabel: 'Current URL',
  contactMethodLabel: 'How would you like to contact us?',
  sendViaEmail: 'Send via Email',
  openWhatsApp: 'Open WhatsApp',
  cancel: 'Cancel',
  submit: 'Submit',
  sending: 'Sending...',
  successEmail: 'Your support request has been sent successfully! We will get back to you soon.',
  successWhatsApp: 'Opening WhatsApp...',
  errorRequired: 'Please describe your problem',
  errorSend: 'Failed to send support request. Please try again.',
  whatsappMessage: 'Hello, I need support with the following issue:\n\nProblem: {problem}\nURL: {url}\n\nPlease help me resolve this issue.',
 },
 pensums: {
  grade: 'Grade',
  newPensum: 'New Pensum',
  editPensumForGrade: 'Edit Pensum for Grade',
  savePensum: 'Save Pensum',
  assignCursosToGrade: 'Assign Cursos to Grade',
  selectCursosToAssign: 'Select cursos to assign to this grade',
  availableCursos: 'Available Cursos',
  selectedCursos: 'Selected Cursos',
  searchCursos: 'Search cursos...',
  searchSelected: 'Search selected...',
  noCursosAvailable: 'No cursos available',
  noCursosSelected: 'No cursos selected',
  add: 'Add',
  addAll: 'Add All',
  remove: 'Remove',
  removeAll: 'Remove All',
  listTitle: 'Pensums',
  filterByGrade: 'Filter by Grade',
  allGrades: 'All Grades',
  searchPensums: 'Search pensums...',
  deletedPensums: 'Deleted Pensums',
  order: 'Order',
  curso: 'Curso',
  noPensumsFound: 'No pensums found',
  cursosCount: '{count} cursos',
  editPensumTitle: 'Edit pensum',
  deletePensum: 'Delete Pensum',
  deletePensumConfirm: 'Are you sure you want to delete this pensum? This action can be undone.',
 },
 cursos: {
  title: 'Courses',
  deletedCursos: 'Deleted Courses',
  newCurso: 'New Course',
  editCurso: 'Edit Course',
  cursoName: 'Course Name',
  saveCurso: 'Save Course',
  updateCurso: 'Update Course',
  pleaseFillRequired: 'Please fill in all required fields',
  cursoCreatedSuccess: 'Course created successfully',
  cursoUpdatedSuccess: 'Course updated successfully',
  errorLoadingCurso: 'Error loading course',
  searchPlaceholder: 'Search courses by name...',
  noCursosFound: 'No courses found',
  deleteCurso: 'Delete Course',
  deleteCursoConfirm: 'Are you sure you want to delete this course? This action can be undone.',
  cursoDeletedSuccess: 'Course deleted successfully',
  errorDeletingCurso: 'Error deleting course',
  errorLoadingCursos: 'Error loading courses',
 },
 attendance: {
  title: 'Attendance',
  subtitle: 'Mark and track student attendance by grade or course.',
  save: 'Save Attendance',
  saving: 'Saving...',
  byGrade: 'By Grade',
  byCourse: 'By Course',
  grade: 'Grade',
  course: 'Course',
  cycle: 'Cycle',
  date: 'Date',
  dateLabel: 'Showing attendance for {date}',
  student: 'Student',
  code: 'Code',
  attendanceColumn: 'Attendance',
  present: 'Present',
  absent: 'Absent',
  late: 'Late',
  summaryPresent: '{count} Present',
  summaryAbsent: '{count} Absent',
  summaryLate: '{count} Late',
  empty: 'No students found for this filter.',
  saveSuccess: 'Attendance saved successfully.',
  saveError: 'Could not save attendance.',
  nothingToSave: 'Mark at least one student before saving.',
  errorLoadingSheet: 'Could not load the attendance sheet.',
  errorLoadingFilters: 'Could not load grades, courses, or cycles.',
  noAssignments: 'You have no grade or course assignments. Contact an administrator.',
 },
 teacherAssignments: {
  title: 'Teacher assignments',
  subtitle: 'Assign grades and/or courses to teachers for attendance scoping.',
  teacher: 'Teacher',
  add: 'Add assignment',
  filterByTeacher: 'Filter by teacher',
  allTeachers: 'All teachers',
  anyCycle: 'Any cycle',
  none: 'None',
  empty: 'No assignments yet.',
  saved: 'Assignment added.',
  saveError: 'Could not save assignment.',
  removed: 'Assignment removed.',
  removeError: 'Could not remove assignment.',
  errorLoading: 'Could not load teacher assignments.',
  needGradeOrCourse: 'Select at least a grade or a course.',
  noPermission: 'You do not have permission to manage teacher assignments.',
 },
 notas: {
  title: 'Student Grades',
  saveNotas: 'Save Notas',
  curso: 'Course',
  nota1: 'Grade 1',
  nota2: 'Grade 2',
  nota3: 'Grade 3',
  nota4: 'Grade 4',
  detalle: 'Detail',
  ausencias: 'Absences',
  reportes: 'Reports',
  tareas: 'Tasks',
  yes: 'Yes',
  no: 'No',
  viewTareas: 'View Tasks',
  tareasFor: 'Tasks for {notaType}',
  name: 'Name',
  total: 'Total',
  yourPunteo: 'Your Score',
  createNewTarea: 'Create New Task for {notaType}',
  totalPoints: 'Total Points',
  addTarea: 'Add Task',
  expand: 'Expand',
  collapse: 'Collapse',
  notasSavedSuccess: 'Notas saved successfully',
  errorSavingNotas: 'Error saving notas',
  errorLoadingStudentData: 'Error loading student data',
  errorLoadingStudents: 'Error loading students',
  errorLoadingCursos: 'Error loading cursos',
  errorLoadingTareas: 'Error loading tareas',
  tareaCreatedSuccess: 'Task created successfully',
  errorCreatingTarea: 'Error creating task',
  scoreUpdatedSuccess: 'Score updated successfully',
  errorUpdatingScore: 'Error updating score',
  tareaDeletedSuccess: 'Task deleted successfully',
  errorDeletingTarea: 'Error deleting task',
  pleaseSaveNotaFirst: 'Please save the nota first',
  pleaseSelectGradeCycle: 'Please select grade and cycle first',
  pleaseFillAllFields: 'Please fill all fields',
  byGrade: 'By Grade',
  byClass: 'By Class',
  classInputMode: 'Class input mode - Coming soon',
  studentsListTitle: 'Students',
  input: 'Input',
  list: 'List',
  pdfGeneratedSuccess: 'PDF generated successfully',
  errorGeneratingPdf: 'Error generating PDF',
  pleaseSelectCycle: 'Please select a cycle',
  bulkPdfGeneratedSuccess: 'Bulk PDF generated successfully',
  errorGeneratingBulkPdf: 'Error generating bulk PDF',
  errorLoadingData: 'Error loading data',
  listCardTitle: 'Students List',
  bulkPrint: 'Bulk Print',
  searchStudent: 'Search Student',
  noStudentsFound: 'No students found',
  inputNotas: 'Input Notas',
  printPdf: 'Print PDF',
 },
 pagination: {
  rowsPerPage: 'Rows per page:',
  displayedRows: '{from}-{to} of {count}',
 },
 tenantRegistration: {
  title: 'Register Your Company',
  subtitle: 'Create a new tenant account to get started with Techno',
  step1: 'Company Information',
  step2: 'Contact Information',
  step3: 'Admin Account',
  companyName: 'Company Name',
  subdomain: 'Subdomain',
  subdomainHint: 'Only lowercase letters, numbers, and hyphens (e.g., mycompany)',
  customDomain: 'Custom Domain (Optional)',
  customDomainHint: 'Your custom domain (e.g., techno.mycompany.com)',
  nit: 'Tax ID (NIT)',
  email: 'Email',
  phone: 'Phone',
  address: 'Address',
  adminAccountTitle: 'Administrator Account',
  adminAccountDescription: 'Create the administrator account for your tenant. This user will have full access to manage your company settings.',
  adminName: 'Administrator Name',
  adminEmail: 'Administrator Email',
  password: 'Password',
  passwordHint: 'Minimum 8 characters',
  confirmPassword: 'Confirm Password',
  alreadyHaveAccount: 'Already have an account?',
  successTitle: 'Registration Successful!',
  successMessage: 'Your tenant account has been created successfully. You will be redirected to the login page shortly.',
  redirecting: 'Redirecting to login...',
  errors: {
    nameRequired: 'Company name is required',
    subdomainRequired: 'Subdomain is required',
    subdomainInvalid: 'Subdomain can only contain lowercase letters, numbers, and hyphens',
    emailRequired: 'Email is required',
    emailInvalid: 'Please enter a valid email address',
    adminNameRequired: 'Administrator name is required',
    adminEmailRequired: 'Administrator email is required',
    passwordRequired: 'Password is required',
    passwordMinLength: 'Password must be at least 8 characters',
    passwordMismatch: 'Passwords do not match',
    registrationFailed: 'Registration failed. Please try again.',
    },
  },
  tenantUsers: {
    title: 'All Tenant Users',
    addUser: 'Add user',
    searchPlaceholder: 'Search users by name, email, or tenant...',
    filterByTenant: 'Filter by Tenant',
    name: 'Name',
    email: 'Email',
    tenant: 'Tenant',
    roles: 'Roles',
    status: 'Status',
    lastLogin: 'Last Login',
    createdAt: 'Created At',
    never: 'Never',
    noUsersFound: 'No users found',
    showingResults: 'Showing {from} to {to} of {total} users',
    confirmDelete: 'Are you sure you want to delete this user?',
    userDeletedSuccess: 'User deleted successfully',
    errorLoadingData: 'Error loading users data',
    errorDeletingUser: 'Error deleting user',
  },
  userManagement: {
    title: 'User Management',
    addUser: 'Add User',
    loadingUsers: 'Loading users...',
    editUser: 'Edit User',
    createUser: 'Create User',
    noTenant: 'No tenant',
    password: 'Password',
    passwordLeaveEmpty: 'Leave empty to keep current password',
    active: 'Active',
    update: 'Update',
    create: 'Create',
    userUpdatedSuccess: 'User updated successfully',
    userCreatedSuccess: 'User created successfully',
    userDeletedSuccess: 'User deleted successfully',
    errorLoadingData: 'Error loading data',
    errorSavingUser: 'Error saving user',
    errorDeletingUser: 'Error deleting user',
    confirmDeleteUser: 'Are you sure you want to delete this user?',
    moreActions: 'More actions',
    sendWelcomeEmail: 'Send welcome email',
    welcomeEmailSentSuccess: 'Welcome email sent successfully',
    failedSendWelcomeEmail: 'Failed to send welcome email',
    noRolesForTenant: 'No roles assigned to this tenant. Configure in Tenant Roles.',
  },

  descounts: {
    title: 'Discounts',
    newDescount: 'New Discount',
    editDescount: 'Edit Discount',
    saveDescount: 'Save Discount',
    updateDescount: 'Update Discount',
    deleteDescount: 'Delete Discount',
    deleteConfirm: 'Are you sure you want to delete this discount?',
    deletedDescounts: 'Deleted Discounts',
    restoreDescount: 'Restore Discount',
    restoreConfirm: 'Are you sure you want to restore this discount?',
    restore: 'Restore',
    percentage: 'Percentage',
    amount: 'Amount',
    deletedAt: 'Deleted At',
    searchPlaceholder: 'Search discounts...',
    noDescountsFound: 'No discounts found',
    noDeletedFound: 'No deleted discounts found',
    pleaseFillRequired: 'Please fill in at least one field',
    oneOfRequired: 'Enter either a percentage or an amount (one is required).',
    onlyOneAllowed: 'Only one of percentage or amount is allowed. Clear the other field.',
    percentageOrAmountHint: 'Enter only one: percentage or amount',
    createdSuccess: 'Discount created successfully',
    updatedSuccess: 'Discount updated successfully',
    deletedSuccess: 'Discount deleted successfully',
    restoredSuccess: 'Discount restored successfully',
    errorLoading: 'Error loading discounts',
    errorLoadingDescount: 'Error loading discount',
    errorDeleting: 'Error deleting discount',
    errorRestoring: 'Error restoring discount',
    errorSaving: 'Error saving discount',
    status: 'Status',
    statusActive: 'Active',
    statusInactive: 'Inactive',
    startDate: 'Start Date',
    endDate: 'End Date',
    activate: 'Activate',
    deactivate: 'Deactivate',
    activatedSuccess: 'Discount activated',
    deactivatedSuccess: 'Discount deactivated',
    errorUpdating: 'Error updating discount',
  },

  clientPayments: {
    title: 'Membership',
    subtitle: 'Manage client memberships and payment assignments',
    assignNew: 'Assign Membership',
    assignDescription: 'Assign a new payment type to a client. If the client already has memberships, you can still add another one.',
    client: 'Client',
    paymentType: 'Payment Type',
    discount: 'Discount',
    isYearBased: 'Is year based',
    startFromPayment: 'Start from payment',
    startFromNow: 'From now (first payment)',
    startFromPaymentNumber: 'Payment #',
    applyMoraToPrevious: 'Apply mora (late fee) to previous pending payments?',
    startDate: 'Start Date',
    endDate: 'End Date',
    nextPayment: 'Next Payment',
    dates: 'Dates',
    selectClient: 'Select Client',
    searchClient: 'Search client by name...',
    selectPaymentType: 'Select a payment type...',
    selectDiscount: 'Select a discount...',
    existingMemberships: 'Existing Memberships',
    noExistingMemberships: 'No existing memberships for this client. A new record will be created.',
    membershipDetail: 'Membership Detail',
    searchPlaceholder: 'Search by client or payment type...',
    noRecordsFound: 'No memberships found',
    notFound: 'Membership not found',
    suspend: 'Suspend',
    reactivate: 'Reactivate',
    suspensionInfo: 'Suspension Information',
    susStart: 'Suspension Start',
    susEnd: 'Suspension End',
    statusActive: 'Active',
    statusSuspended: 'Suspended',
    statusEnded: 'Ended',
    pleaseFillRequired: 'Please select a client, payment type and discount',
    pleaseFillDates: 'Please fill in the start and end dates',
    createdSuccess: 'Membership assigned successfully',
    suspendedSuccess: 'Membership suspended successfully',
    reactivatedSuccess: 'Membership reactivated successfully',
    errorLoading: 'Error loading memberships',
    errorLoadingData: 'Error loading data',
    errorSaving: 'Error assigning membership',
    errorUpdating: 'Error updating membership',
  },

  paymentTypes: {
    title: 'Payment Types',
    newPaymentType: 'New Payment Type',
    editPaymentType: 'Edit Payment Type',
    savePaymentType: 'Save Payment Type',
    updatePaymentType: 'Update Payment Type',
    deletePaymentType: 'Delete Payment Type',
    deleteConfirm: 'Are you sure you want to delete this payment type?',
    deletedPaymentTypes: 'Deleted Payment Types',
    restorePaymentType: 'Restore Payment Type',
    restoreConfirm: 'Are you sure you want to restore this payment type?',
    restore: 'Restore',
    amount: 'Amount',
    lateFee: 'Late Fee',
    lateFeeDays: 'Late Fee Days',
    installments: 'Installments',
    frequency: 'Frequency',
    recurrence: 'Recurrence',
    byDate: 'By Date',
    indefinite: 'Indefinite',
    indefiniteHelp: 'No fixed number of payments; client pays for service and may stop anytime.',
    indefiniteLabel: 'Indefinite',
    monthly: 'Monthly',
    annual: 'Annual',
    daily: 'Daily',
    deletedAt: 'Deleted At',
    searchPlaceholder: 'Search payment types...',
    noPaymentTypesFound: 'No payment types found',
    noDeletedFound: 'No deleted payment types found',
    pleaseFillRequired: 'Please fill in the required fields',
    createdSuccess: 'Payment type created successfully',
    updatedSuccess: 'Payment type updated successfully',
    deletedSuccess: 'Payment type deleted successfully',
    restoredSuccess: 'Payment type restored successfully',
    errorLoading: 'Error loading payment types',
    errorLoadingPaymentType: 'Error loading payment type',
    errorDeleting: 'Error deleting payment type',
    errorRestoring: 'Error restoring payment type',
    errorSaving: 'Error saving payment type',
  },

  payments: {
    title: 'Payments',
    subtitle: 'View payment status by client and membership. Green = paid, red = pending.',
    client: 'Client',
    membership: 'Membership',
    paymentsStatus: 'Payment status',
    byYear: 'By year',
    pending: 'pending',
    howManyInstallments: 'How many installments?',
    oneInstallment: 'installment',
    installmentsLabel: 'installments',
    noPendingInstallments: 'No pending installments for this membership.',
    cancelled: 'Cancelled',
    searchPlaceholder: 'Search by client or membership...',
    noRecordsFound: 'No records found',
    registerPayment: 'Register Payment',
    selectMembership: 'Select membership',
    enterAmount: 'Please enter a valid amount',
    selectMethod: 'Select at least one payment method',
    amount: 'Amount',
    lateFee: 'Late fee',
    cash: 'Cash',
    cheque: 'Cheque',
    card: 'Card',
    attachmentButton: 'Add attachment',
    attachmentHelp: 'Optional file (image/PDF) as payment confirmation.',
    registeredSuccess: 'Payment registered successfully',
    errorLoading: 'Error loading payments',
    errorRegistering: 'Error registering payment',
    viewList: 'List',
    viewGrouped: 'By client',
    filterByMembershipType: 'Membership type',
    allMembershipTypes: 'All',
    oneMembership: '1 membership',
    manyMemberships: '{count} memberships',
    paidCountLabel: '{count} payments',
    paidCountSinceStart: '{count} payments since {date}',
    indefiniteOneAtATime: 'Only the current payment (1 installment) for indefinite memberships.',
  },
};
